var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeploy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_3_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 354.268,
    rx: 240.055,
    ry: 138.596
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_10_",
    style: {
      fill: "#EBEBEB"
    },
    d: "M27.522,380.511l90.553-52.281c1.546-0.893,4.054-0.893,5.601,0l83.718,48.334 c1.547,0.893,1.547,2.341,0,3.234l-90.554,52.281c-1.547,0.893-4.054,0.893-5.601,0l-83.716-48.334 C25.975,382.852,25.975,381.404,27.522,380.511z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Shadow_7_",
    style: {
      fill: "#EBEBEB"
    },
    cx: 394.777,
    cy: 399.828,
    rx: 55.86,
    ry: 32.251
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1140_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1149_",
    style: {
      fill: "#5f95fa"
    },
    d: "M419.897,386.091c0,0-2.026-28.311,10.512-54.618 c7.008-14.704,17.678-20.787,23.868-20.859c6.938-0.081,13.25,7.093,6.183,16.549c-6.715,8.985-18.274,11.772-27.249,36.047 c-5.917,16.004-6.307,26.927-6.307,26.927L419.897,386.091z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1148_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M419.897,386.091c0,0-2.026-28.311,10.512-54.618 c7.008-14.704,17.678-20.787,23.868-20.859c6.938-0.081,13.25,7.093,6.183,16.549c-6.715,8.985-18.274,11.772-27.249,36.047 c-5.917,16.004-6.307,26.927-6.307,26.927L419.897,386.091z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1146_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M424.843,379.458c0.238,0,0.431-0.192,0.431-0.431c0-30.762,17.156-54.813,29.338-62.067 c0.204-0.123,0.272-0.387,0.15-0.592c-0.124-0.206-0.387-0.272-0.592-0.15c-12.356,7.358-29.758,31.709-29.758,62.809 C424.412,379.265,424.604,379.458,424.843,379.458z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1118_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1139_",
    style: {
      fill: "#5f95fa"
    },
    d: "M426.905,390.137c1.694-6.908,6.276-13.725,15.335-20.535 c9.059-6.811,21.17-12.654,20.176-19.605c-0.994-6.951-10.169-6.467-16.889-3.395c-6.72,3.072-22.445,16.394-22.126,41.511 L426.905,390.137z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1138_",
    style: {
      opacity: 0.65,
      fill: "#FFFFFF"
    },
    d: "M426.905,390.137c1.694-6.908,6.276-13.725,15.335-20.535 c9.059-6.811,21.17-12.654,20.176-19.605c-0.994-6.951-10.169-6.467-16.889-3.395c-6.72,3.072-22.445,16.394-22.126,41.511 L426.905,390.137z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1136_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M425.945,382.127c0.204,0,0.386-0.145,0.423-0.353c2.678-14.693,21.623-31.496,29.791-33.53 c0.232-0.057,0.372-0.292,0.314-0.522c-0.056-0.232-0.288-0.374-0.522-0.314c-8.565,2.132-27.648,18.941-30.431,34.211 c-0.043,0.235,0.112,0.459,0.346,0.501C425.893,382.125,425.919,382.127,425.945,382.127z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Gears"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gears_4_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gears_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3799_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3857_",
    style: {
      fill: "#5f95fa"
    },
    d: "M260.533,237.036l-4.82-2.765l0,0.003c-0.13-0.074-0.303-0.079-0.495,0.007 l-5.698,2.569c-0.402,0.181-0.816-0.019-0.949-0.44c-0.331-1.047,0.907-1.044,0.395-1.879c-0.231-0.376-0.283-0.985-0.087-1.381 l3.798-7.658c0.196-0.395,0.045-0.895-0.337-1.115l-5.787-3.326c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118 c-0.244,0.367-0.798,0.627-1.24,0.615c-0.536-0.014-1.088,0.014-1.653,0.077l1.666-4.259l-4.828-2.77v0.001 c-0.14-0.075-0.324-0.066-0.517,0.046l-6.402,3.696c-0.382,0.221-0.724,0.755-0.764,1.195l-0.641,7.123 c-0.04,0.439-0.341,1.031-0.666,1.33c-1.246,1.147-2.436,2.411-3.556,3.764c-0.281,0.34-0.841,0.502-1.258,0.356l-4.109-1.435 c-0.417-0.145-0.933,0.046-1.154,0.428l-4.707,8.152c-0.221,0.382-0.128,0.925,0.206,1.213l3.298,2.841 c0.334,0.288,0.473,0.854,0.32,1.268c-0.611,1.647-1.111,3.31-1.482,4.962c-0.097,0.43-0.458,0.987-0.819,1.241l-5.848,4.117 c-0.361,0.254-0.653,0.818-0.653,1.259v7.392c0,0.228,0.088,0.392,0.227,0.475l-0.001,0.001l4.819,2.764l3.018-3.163 c0.181,0.38,0.373,0.746,0.583,1.089c0.23,0.376,0.283,0.985,0.087,1.381l-3.798,7.658c-0.196,0.395-0.045,0.894,0.337,1.115 l5.787,3.326c0.382,0.221,0.89,0.102,1.134-0.266l3.067-8.065c0.244-0.367,0.799-0.627,1.24-0.615 c0.979,0.026,2.01-0.076,3.082-0.313c0.431-0.095,0.811,0.163,0.855,0.602l0.625,6.22c0.021,0.212,0.114,0.361,0.246,0.436 l-0.002,0.001l4.813,2.762l3.781-5.553c0.382-0.221,0.724-0.756,0.763-1.195l-1.024-8.07c0.04-0.439,0.412-0.907,0.819-1.077 c1.829-0.766,3.678-2.09,4.973-3.488c0.3-0.324,0.859-0.487,1.275-0.34l2.523,0.888c0.416,0.147,0.932-0.044,1.153-0.426 l4.706-8.152c0.221-0.382,0.129-0.925-0.206-1.213l-2.168-1.868c-0.334-0.288-0.473-0.854-0.352-1.279 c0.52-1.824,0.638-4.21,0.588-5.908c-0.013-0.441,0.254-1.004,0.615-1.258l7.514-3.17c0.361-0.254,0.653-0.817,0.653-1.259 l2.795-3.35L260.533,237.036z M232.578,266.336c-5.973,3.449-9.686,1.002-9.686-5.895c0-6.897,4.936-15.346,10.909-18.794 c5.973-3.449,9.591-0.94,9.591,5.957C243.393,254.5,238.551,262.887,232.578,266.336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3850_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M260.533,237.036l-4.82-2.765l0,0.003 c-0.13-0.074-0.303-0.079-0.495,0.007l-5.698,2.569c-0.402,0.181-0.816-0.019-0.949-0.44c-0.331-1.047,0.907-1.044,0.395-1.879 c-0.231-0.376-0.283-0.985-0.087-1.381l3.798-7.658c0.196-0.395,0.045-0.895-0.337-1.115l-5.787-3.326 c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118c-0.244,0.367-0.798,0.627-1.24,0.615c-0.536-0.014-1.088,0.014-1.653,0.077 l1.666-4.259l-4.828-2.77v0.001c-0.14-0.075-0.324-0.066-0.517,0.046l-6.402,3.696c-0.382,0.221-0.724,0.755-0.764,1.195 l-0.641,7.123c-0.04,0.439-0.341,1.031-0.666,1.33c-1.246,1.147-2.436,2.411-3.556,3.764c-0.281,0.34-0.841,0.502-1.258,0.356 l-4.109-1.435c-0.417-0.145-0.933,0.046-1.154,0.428l-4.707,8.152c-0.221,0.382-0.128,0.925,0.206,1.213l3.298,2.841 c0.334,0.288,0.473,0.854,0.32,1.268c-0.611,1.647-1.111,3.31-1.482,4.962c-0.097,0.43-0.458,0.987-0.819,1.241l-5.848,4.117 c-0.361,0.254-0.653,0.818-0.653,1.259v7.392c0,0.228,0.088,0.392,0.227,0.475l-0.001,0.001l4.819,2.764l3.018-3.163 c0.181,0.38,0.373,0.746,0.583,1.089c0.23,0.376,0.283,0.985,0.087,1.381l-3.798,7.658c-0.196,0.395-0.045,0.894,0.337,1.115 l5.787,3.326c0.382,0.221,0.89,0.102,1.134-0.266l3.067-8.065c0.244-0.367,0.799-0.627,1.24-0.615 c0.979,0.026,2.01-0.076,3.082-0.313c0.431-0.095,0.811,0.163,0.855,0.602l0.625,6.22c0.021,0.212,0.114,0.361,0.246,0.436 l-0.002,0.001l4.813,2.762l3.781-5.553c0.382-0.221,0.724-0.756,0.763-1.195l-1.024-8.07c0.04-0.439,0.412-0.907,0.819-1.077 c1.829-0.766,3.678-2.09,4.973-3.488c0.3-0.324,0.859-0.487,1.275-0.34l2.523,0.888c0.416,0.147,0.932-0.044,1.153-0.426 l4.706-8.152c0.221-0.382,0.129-0.925-0.206-1.213l-2.168-1.868c-0.334-0.288-0.473-0.854-0.352-1.279 c0.52-1.824,0.638-4.21,0.588-5.908c-0.013-0.441,0.254-1.004,0.615-1.258l7.514-3.17c0.361-0.254,0.653-0.817,0.653-1.259 l2.795-3.35L260.533,237.036z M232.578,266.336c-5.973,3.449-9.686,1.002-9.686-5.895c0-6.897,4.936-15.346,10.909-18.794 c5.973-3.449,9.591-0.94,9.591,5.957C243.393,254.5,238.551,262.887,232.578,266.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M232.983,275.638l-9.331-3.908l-7.955-4.103l-3.364,5.998l1.608-2.496 c0.181,0.38,0.373,0.746,0.583,1.089c0.23,0.376,0.283,0.985,0.087,1.381l-3.798,7.658c-0.196,0.395-0.045,0.894,0.337,1.115 l5.787,3.326c0.382,0.221,0.89,0.102,1.134-0.266l3.067-8.065c0.244-0.367,0.799-0.627,1.24-0.615 c0.979,0.026,2.01-0.076,3.082-0.313c0.431-0.095,0.811,0.163,0.855,0.602l0.625,6.22c0.021,0.212,0.114,0.361,0.246,0.436 l-0.001,0.001l4.813,2.762l1.786-2.624L232.983,275.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M247.866,253.016V240.65l-5.224-4.42l-2.467,4.176c2.07,0.82,3.218,3.312,3.218,7.196 c0,6.898-4.842,15.284-10.815,18.733c-3.502,2.022-6.218,2.004-7.873,0.264l-1.788,3.028c0,0,8.777,2.715,12.81,1.024 C239.758,268.96,247.866,253.016,247.866,253.016z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3844_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3849_",
    style: {
      fill: "#5f95fa"
    },
    d: "M251.421,228.025l1.256-2.533c0.196-0.395,0.045-0.895-0.337-1.115 l-5.787-3.326c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118c-0.077,0.116-0.19,0.214-0.315,0.303l6.963,4.005 L251.421,228.025z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3848_",
    style: {
      fill: "#5f95fa"
    },
    d: "M212.832,257.802c-0.137,0.193-0.293,0.369-0.452,0.481l-5.848,4.117 c-0.147,0.104-0.276,0.265-0.385,0.442l5.234,3.007l7.764-4.417L212.832,257.802z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3847_",
    style: {
      fill: "#5f95fa"
    },
    d: "M216.387,238.129c-0.329,0.012-0.659,0.191-0.823,0.476l-4.707,8.152 c-0.103,0.178-0.131,0.39-0.106,0.595l5.722,3.289l6.442-8.715L216.387,238.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3846_",
    style: {
      fill: "#5f95fa"
    },
    d: "M227.072,226.613l6.685,3.844l5.701-3.292v-2.297l-4.828-2.77v0.001 c-0.14-0.075-0.324-0.066-0.517,0.046l-6.402,3.696C227.448,225.994,227.211,226.297,227.072,226.613z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3845_",
    style: {
      fill: "#5f95fa"
    },
    d: "M260.535,237.037v0.005c-0.128-0.085-0.309-0.09-0.506,0l-5.699,2.567 c-0.399,0.181-0.815-0.016-0.948-0.437c-0.224-0.719-1.582-2.64-1.462-3.406l3.295-1.487c0.192-0.085,0.367-0.08,0.495-0.005 v-0.005L260.535,237.037z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3838_",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3843_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.421,228.025l1.256-2.533c0.196-0.395,0.045-0.895-0.337-1.115l-5.787-3.326 c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118c-0.077,0.116-0.19,0.214-0.315,0.303l6.963,4.005L251.421,228.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.897,228.679l6.37,3.663l3.891-4.493l1.239-2.497c0.121-0.245,0.024-0.567-0.213-0.703 l-5.787-3.326c-0.238-0.138-0.565-0.06-0.716,0.168l-4.733,7.118C240.932,228.633,240.915,228.656,240.897,228.679z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3842_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.832,257.802c-0.137,0.193-0.293,0.369-0.452,0.481l-5.848,4.117 c-0.147,0.104-0.276,0.265-0.385,0.442l5.234,3.007l7.764-4.417L212.832,257.802z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M206.61,262.746l4.771,2.741l7.131-4.057l-5.6-3.219c-0.116,0.137-0.234,0.247-0.352,0.329 l-5.848,4.116C206.679,262.68,206.645,262.71,206.61,262.746z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3841_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M216.387,238.129c-0.329,0.012-0.659,0.191-0.823,0.476l-4.707,8.152 c-0.103,0.178-0.131,0.39-0.106,0.595l5.722,3.289l6.442-8.715L216.387,238.129z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3840_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.072,226.613l6.685,3.844l5.701-3.292v-2.297l-4.828-2.77v0.001 c-0.14-0.075-0.324-0.066-0.517,0.046l-6.402,3.696C227.448,225.994,227.211,226.297,227.072,226.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.494,226.494l6.262,3.601l5.388-3.111v-1.934l-4.67-2.679 c-0.037-0.019-0.117-0.004-0.204,0.046l-6.402,3.697C227.739,226.189,227.604,226.328,227.494,226.494z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3839_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.535,237.037v0.005c-0.128-0.085-0.309-0.09-0.506,0l-5.699,2.567 c-0.399,0.181-0.815-0.016-0.948-0.437c-0.224-0.719-1.597-2.699-1.462-3.406l3.295-1.487c0.192-0.085,0.367-0.08,0.495-0.005 v-0.005L260.535,237.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M252.232,235.971c0.064,0.435,0.552,1.331,0.858,1.893c0.27,0.496,0.503,0.924,0.593,1.214 c0.038,0.12,0.113,0.211,0.211,0.255c0.093,0.042,0.2,0.038,0.307-0.011l5.427-2.445l-3.602-2.067v0.004l-0.472-0.27 c-0.034-0.021-0.108-0.025-0.21,0.021L252.232,235.971z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3835_",
    style: {
      fill: "#5f95fa"
    },
    d: "M260.76,244.906v-7.393c0-0.441-0.326-0.652-0.728-0.471l-5.698,2.569 c-0.402,0.181-0.816-0.019-0.949-0.439c-0.331-1.047-0.759-1.99-1.27-2.825c-0.231-0.376-0.283-0.986-0.087-1.381l3.798-7.658 c0.196-0.395,0.045-0.895-0.337-1.115l-4.122-2.38c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118 c-0.244,0.367-0.798,0.627-1.239,0.615c-0.979-0.025-2.009,0.076-3.082,0.313c-0.431,0.095-0.811-0.163-0.855-0.602 l-0.625-6.219c-0.044-0.439-0.39-0.616-0.772-0.395l-6.402,3.696c-0.382,0.221-0.724,0.756-0.764,1.195l-0.641,7.123 c-0.04,0.439-0.341,1.031-0.666,1.33c-1.246,1.147-2.436,2.411-3.556,3.764c-0.281,0.34-0.841,0.502-1.258,0.356l-4.11-1.435 c-0.417-0.146-0.933,0.046-1.154,0.428l-4.706,8.152c-0.221,0.382-0.128,0.925,0.206,1.213l3.297,2.841 c0.334,0.288,0.474,0.854,0.32,1.268c-0.611,1.647-1.111,3.309-1.481,4.962c-0.096,0.43-0.458,0.987-0.819,1.241l-5.848,4.117 c-0.361,0.254-0.653,0.817-0.653,1.259v7.392c0,0.441,0.326,0.652,0.728,0.471l5.698-2.569c0.402-0.181,0.816,0.019,0.949,0.439 c0.331,1.047,0.758,1.99,1.27,2.825c0.23,0.376,0.283,0.986,0.086,1.381l-3.798,7.658c-0.196,0.395-0.045,0.894,0.337,1.115 l4.122,2.379c0.382,0.221,0.89,0.102,1.134-0.266l4.733-7.118c0.244-0.367,0.799-0.627,1.24-0.616 c0.979,0.025,2.009-0.076,3.082-0.313c0.431-0.095,0.811,0.163,0.855,0.602l0.625,6.219c0.044,0.439,0.39,0.616,0.772,0.396 l6.402-3.696c0.382-0.221,0.724-0.756,0.763-1.195l0.641-7.123c0.039-0.439,0.341-1.031,0.666-1.33 c1.246-1.147,2.435-2.411,3.555-3.763c0.281-0.34,0.842-0.502,1.258-0.357l4.11,1.435c0.417,0.145,0.933-0.046,1.154-0.428 l4.707-8.152c0.221-0.382,0.129-0.925-0.206-1.213l-3.298-2.841c-0.334-0.288-0.474-0.854-0.32-1.268 c0.611-1.647,1.111-3.309,1.482-4.962c0.096-0.43,0.458-0.987,0.819-1.241l5.848-4.117 C260.467,245.91,260.76,245.347,260.76,244.906z M235.726,268.151c-5.973,3.449-10.816,0.653-10.816-6.244 c0-6.897,4.843-15.284,10.816-18.733c5.973-3.448,10.815-0.653,10.815,6.244C246.541,256.315,241.699,264.702,235.726,268.151z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3829_",
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.76,244.906v-7.393c0-0.441-0.326-0.652-0.728-0.471l-5.698,2.569 c-0.402,0.181-0.816-0.019-0.949-0.439c-0.331-1.047-0.759-1.99-1.27-2.825c-0.231-0.376-0.283-0.986-0.087-1.381l3.798-7.658 c0.196-0.395,0.045-0.895-0.337-1.115l-4.122-2.38c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118 c-0.244,0.367-0.798,0.627-1.239,0.615c-0.979-0.025-2.009,0.076-3.082,0.313c-0.431,0.095-0.811-0.163-0.855-0.602 l-0.625-6.219c-0.044-0.439-0.39-0.616-0.772-0.395l-6.402,3.696c-0.382,0.221-0.724,0.756-0.764,1.195l-0.641,7.123 c-0.04,0.439-0.341,1.031-0.666,1.33c-1.246,1.147-2.436,2.411-3.556,3.764c-0.281,0.34-0.841,0.502-1.258,0.356l-4.11-1.435 c-0.417-0.146-0.933,0.046-1.154,0.428l-4.706,8.152c-0.221,0.382-0.128,0.925,0.206,1.213l3.297,2.841 c0.334,0.288,0.474,0.854,0.32,1.268c-0.611,1.647-1.111,3.309-1.481,4.962c-0.096,0.43-0.458,0.987-0.819,1.241l-5.848,4.117 c-0.361,0.254-0.653,0.817-0.653,1.259v7.392c0,0.441,0.326,0.652,0.728,0.471l5.698-2.569 c0.402-0.181,0.816,0.019,0.949,0.439c0.331,1.047,0.758,1.99,1.27,2.825c0.23,0.376,0.283,0.986,0.086,1.381l-3.798,7.658 c-0.196,0.395-0.045,0.894,0.337,1.115l4.122,2.379c0.382,0.221,0.89,0.102,1.134-0.266l4.733-7.118 c0.244-0.367,0.799-0.627,1.24-0.616c0.979,0.025,2.009-0.076,3.082-0.313c0.431-0.095,0.811,0.163,0.855,0.602l0.625,6.219 c0.044,0.439,0.39,0.616,0.772,0.396l6.402-3.696c0.382-0.221,0.724-0.756,0.763-1.195l0.641-7.123 c0.039-0.439,0.341-1.031,0.666-1.33c1.246-1.147,2.435-2.411,3.555-3.763c0.281-0.34,0.842-0.502,1.258-0.357l4.11,1.435 c0.417,0.145,0.933-0.046,1.154-0.428l4.707-8.152c0.221-0.382,0.129-0.925-0.206-1.213l-3.298-2.841 c-0.334-0.288-0.474-0.854-0.32-1.268c0.611-1.647,1.111-3.309,1.482-4.962c0.096-0.43,0.458-0.987,0.819-1.241l5.848-4.117 C260.467,245.91,260.76,245.347,260.76,244.906z M235.726,268.151c-5.973,3.449-10.816,0.653-10.816-6.244 c0-6.897,4.843-15.284,10.816-18.733c5.973-3.448,10.815-0.653,10.815,6.244C246.541,256.315,241.699,264.702,235.726,268.151z "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M235.883,268.423c6.05-3.493,10.972-12.019,10.972-19.005c0-3.453-1.181-6.036-3.325-7.274 c-2.144-1.238-4.971-0.969-7.961,0.757c-6.051,3.493-10.973,12.019-10.973,19.005c0,3.452,1.181,6.036,3.325,7.273 c0.887,0.512,1.89,0.766,2.974,0.766C232.432,269.947,234.13,269.435,235.883,268.423z M224.91,261.907 c0-6.897,4.843-15.284,10.816-18.733c5.973-3.448,10.815-0.653,10.815,6.244c0,6.897-4.842,15.284-10.815,18.733 C229.753,271.6,224.91,268.804,224.91,261.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M215.963,285.133l4.122,2.379c0.382,0.22,0.89,0.102,1.134-0.266l4.733-7.118 c0.244-0.367,0.799-0.627,1.24-0.616c0.979,0.025,2.01-0.076,3.082-0.313c0.431-0.095,0.811,0.163,0.855,0.602l0.625,6.219 c0.044,0.439,0.389,0.616,0.772,0.396l6.402-3.696c0.382-0.221,0.724-0.756,0.763-1.195l0.641-7.123 c0.039-0.439,0.341-1.031,0.666-1.33c1.246-1.147,2.435-2.411,3.555-3.763c0.281-0.34,0.842-0.502,1.258-0.357l4.11,1.435 c0.417,0.146,0.933-0.046,1.154-0.428l4.707-8.152c0.221-0.382,0.128-0.925-0.206-1.213l-3.298-2.841 c-0.334-0.288-0.474-0.854-0.32-1.268c0.611-1.647,1.111-3.309,1.482-4.962c0.097-0.431,0.458-0.987,0.819-1.241l5.848-4.117 c0.361-0.254,0.653-0.818,0.653-1.259l0-7.393c0-0.441-0.326-0.652-0.728-0.471l-5.698,2.569 c-0.402,0.181-0.816-0.019-0.949-0.44c-0.331-1.047-0.759-1.99-1.27-2.825c-0.23-0.376-0.283-0.985-0.087-1.381l3.798-7.658 c0.196-0.395,0.045-0.895-0.337-1.115l-4.122-2.38c-0.382-0.221-0.89-0.102-1.134,0.266l-4.733,7.118 c-0.244,0.367-0.798,0.627-1.239,0.615c-0.979-0.025-2.009,0.076-3.082,0.313c-0.431,0.095-0.811-0.163-0.855-0.602 l-0.625-6.219c-0.044-0.439-0.389-0.616-0.772-0.395l-6.402,3.696c-0.382,0.221-0.724,0.756-0.764,1.195l-0.641,7.123 c-0.04,0.439-0.341,1.031-0.666,1.33c-1.246,1.147-2.436,2.411-3.556,3.764c-0.281,0.34-0.841,0.502-1.258,0.356l-4.11-1.435 c-0.416-0.146-0.933,0.046-1.154,0.428l-4.706,8.152c-0.221,0.382-0.128,0.925,0.206,1.213l3.297,2.841 c0.334,0.288,0.474,0.854,0.32,1.268c-0.611,1.647-1.111,3.309-1.481,4.962c-0.096,0.43-0.458,0.987-0.819,1.241l-5.848,4.117 c-0.361,0.254-0.653,0.817-0.653,1.259v7.392c0,0.441,0.326,0.652,0.728,0.47l5.698-2.569c0.402-0.181,0.816,0.019,0.949,0.439 c0.331,1.047,0.758,1.99,1.27,2.825c0.23,0.376,0.283,0.986,0.086,1.381l-3.798,7.658 C215.43,284.413,215.581,284.912,215.963,285.133z M215.908,284.158l3.798-7.658c0.238-0.479,0.195-1.203-0.1-1.685 c-0.503-0.822-0.92-1.749-1.239-2.756c-0.094-0.296-0.291-0.524-0.556-0.642c-0.125-0.056-0.258-0.083-0.392-0.083 c-0.143,0-0.289,0.031-0.43,0.095l-5.698,2.569c-0.092,0.041-0.172,0.048-0.215,0.021c-0.044-0.028-0.07-0.105-0.07-0.205 v-7.392c0-0.339,0.243-0.807,0.52-1.002l5.849-4.117c0.423-0.297,0.828-0.912,0.944-1.429c0.362-1.613,0.857-3.269,1.47-4.921 c0.199-0.536,0.019-1.245-0.41-1.615l-3.298-2.841c-0.221-0.19-0.285-0.565-0.139-0.818l4.706-8.152 c0.146-0.253,0.503-0.385,0.778-0.289l4.11,1.435c0.534,0.185,1.238-0.013,1.603-0.453c1.123-1.356,2.31-2.612,3.527-3.734 c0.39-0.359,0.72-1.018,0.766-1.533l0.641-7.123c0.03-0.337,0.314-0.782,0.608-0.951l6.402-3.696 c0.087-0.051,0.167-0.067,0.212-0.042c0.046,0.024,0.08,0.097,0.09,0.197l0.624,6.219c0.03,0.297,0.173,0.552,0.402,0.718 c0.235,0.17,0.53,0.227,0.833,0.16c1.032-0.228,2.041-0.33,3.006-0.305c0.577,0.017,1.213-0.31,1.509-0.756l4.733-7.119 c0.151-0.227,0.477-0.305,0.716-0.167l4.122,2.38c0.236,0.136,0.334,0.459,0.213,0.704l-3.798,7.658 c-0.238,0.479-0.195,1.203,0.1,1.684c0.504,0.822,0.921,1.749,1.239,2.756c0.094,0.296,0.291,0.524,0.555,0.642 c0.258,0.114,0.549,0.111,0.822-0.011l5.698-2.568c0.091-0.042,0.171-0.049,0.215-0.021c0.043,0.028,0.07,0.105,0.07,0.205 l0,7.393c0,0.339-0.243,0.807-0.52,1.002l-5.848,4.116c-0.423,0.297-0.829,0.912-0.945,1.429 c-0.362,1.612-0.856,3.267-1.47,4.922c-0.199,0.536-0.019,1.246,0.41,1.615l3.298,2.841c0.221,0.19,0.285,0.565,0.139,0.818 l-4.707,8.152c-0.146,0.253-0.502,0.386-0.778,0.289l-4.109-1.435c-0.533-0.186-1.238,0.012-1.604,0.453 c-1.125,1.359-2.312,2.614-3.526,3.733c-0.384,0.353-0.72,1.027-0.766,1.533l-0.641,7.124c-0.03,0.337-0.314,0.782-0.608,0.951 l-6.402,3.697c-0.087,0.05-0.166,0.066-0.212,0.042c-0.046-0.024-0.08-0.097-0.09-0.197l-0.624-6.22 c-0.03-0.297-0.172-0.552-0.401-0.717c-0.234-0.17-0.53-0.226-0.834-0.16c-1.032,0.227-2.046,0.33-3.006,0.306 c-0.564-0.013-1.213,0.31-1.51,0.756l-4.733,7.118c-0.151,0.227-0.479,0.304-0.716,0.168l-4.122-2.379 C215.883,284.724,215.786,284.402,215.908,284.158z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3595_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3785_",
    style: {
      fill: "#5f95fa"
    },
    d: "M295.983,189.592l0.001,0.007c-0.203-0.122-0.472-0.112-0.747,0.069 l-3.606,2.373c-0.493,0.325-1.109,0.157-1.447-0.326c-0.218-0.311-0.452-0.598-0.703-0.861 c-0.407-0.428-0.628-1.163-0.423-1.717l5.73-3.632l-4.278-2.469l-0.003,0.004c-0.086-0.049-0.178-0.091-0.283-0.114 l-2.718-0.608c-0.576-0.129-1.266,0.191-1.54,0.714l-2.556,4.87c-0.274,0.523-0.972,1.016-1.544,1.161 c-0.052,0.013-0.105,0.032-0.157,0.046c0.157-0.461,0.224-1.133,0.224-1.133l-4.29-2.476l0.001,0.005 c-0.23-0.134-0.525-0.109-0.804,0.11l-4.073,3.202c-0.464,0.365-0.811,1.139-0.774,1.728l0.243,3.875 c0.037,0.59-0.255,1.422-0.633,1.875c-0.668,0.798-1.299,1.636-1.891,2.503c-0.333,0.488-1.068,0.869-1.657,0.84l-2.618-0.129 c-0.59-0.029-1.263,0.385-1.504,0.924l-2.462,5.519c-0.22,0.494-0.03,1.056,0.42,1.326l-0.001,0.005l2.902,1.675 c0.094,0.238,0.125,0.501,0.068,0.751c-0.202,0.887-0.354,1.768-0.453,2.633c-0.067,0.587-0.448,1.389-0.882,1.788l-3.609,3.318 c-0.435,0.4-0.706,1.196-0.606,1.778l0.678,3.936c0.044,0.257,0.165,0.435,0.325,0.533l-0.005,0.003l4.304,2.484l0.057-4.927 c0.493-0.325,1.109-0.157,1.447,0.326c0.218,0.311,0.452,0.598,0.703,0.861c0.407,0.428,0.627,1.164,0.422,1.718l-1.839,4.974 c-0.163,0.441-0.002,0.878,0.36,1.105l-0.003,0.004l4.297,2.48l1.171-3.202l1.661-4.126c0.274-0.523,0.972-1.016,1.544-1.161 c0.547-0.139,1.106-0.323,1.674-0.553c0.547-0.222,1.115,0.022,1.285,0.587l0.919,3.05c0.069,0.228,0.195,0.387,0.35,0.476 l-0.003,0.003l4.31,2.485l-0.754-4.766l1.319-1.037c0.464-0.365,0.811-1.139,0.774-1.728l-0.243-3.875 c-0.037-0.589,0.255-1.422,0.634-1.875c0.668-0.798,1.675-1.225,2.268-2.092c0.333-0.488,0.691-1.281,1.281-1.251l2.618,0.129 c0.59,0.029,1.263-0.384,1.504-0.924l2.462-5.519c0.241-0.539-0.005-1.164-0.548-1.396l-2.115-0.902 c-0.543-0.232-0.857-0.882-0.726-1.458c0.202-0.887,0.354-1.768,0.453-2.632c0.067-0.587,0.447-1.388,0.882-1.788l3.609-3.318 c0.309-0.284,0.527-0.767,0.597-1.232l3.278-2.556L295.983,189.592z M279.596,215.042c-4.414,3.471-8.64,2.525-9.439-2.111 c-0.798-4.636,2.814-10.528,7.228-13.998c4.414-3.471,7.959-3.207,8.757,1.43C286.941,204.999,284.01,211.572,279.596,215.042z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3734_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M295.983,189.592l0.001,0.007 c-0.203-0.122-0.472-0.112-0.747,0.069l-3.606,2.373c-0.493,0.325-1.109,0.157-1.447-0.326 c-0.218-0.311-0.452-0.598-0.703-0.861c-0.407-0.428-0.628-1.163-0.423-1.717l5.73-3.632l-4.278-2.469l-0.003,0.004 c-0.086-0.049-0.178-0.091-0.283-0.114l-2.718-0.608c-0.576-0.129-1.266,0.191-1.54,0.714l-2.556,4.87 c-0.274,0.523-0.972,1.016-1.544,1.161c-0.052,0.013-0.105,0.032-0.157,0.046c0.157-0.461,0.224-1.133,0.224-1.133l-4.29-2.476 l0.001,0.005c-0.23-0.134-0.525-0.109-0.804,0.11l-4.073,3.202c-0.464,0.365-0.811,1.139-0.774,1.728l0.243,3.875 c0.037,0.59-0.255,1.422-0.633,1.875c-0.668,0.798-1.299,1.636-1.891,2.503c-0.333,0.488-1.068,0.869-1.657,0.84l-2.618-0.129 c-0.59-0.029-1.263,0.385-1.504,0.924l-2.462,5.519c-0.22,0.494-0.03,1.056,0.42,1.326l-0.001,0.005l2.902,1.675 c0.094,0.238,0.125,0.501,0.068,0.751c-0.202,0.887-0.354,1.768-0.453,2.633c-0.067,0.587-0.448,1.389-0.882,1.788l-3.609,3.318 c-0.435,0.4-0.706,1.196-0.606,1.778l0.678,3.936c0.044,0.257,0.165,0.435,0.325,0.533l-0.005,0.003l4.304,2.484l0.057-4.927 c0.493-0.325,1.109-0.157,1.447,0.326c0.218,0.311,0.452,0.598,0.703,0.861c0.407,0.428,0.627,1.164,0.422,1.718l-1.839,4.974 c-0.163,0.441-0.002,0.878,0.36,1.105l-0.003,0.004l4.297,2.48l1.171-3.202l1.661-4.126c0.274-0.523,0.972-1.016,1.544-1.161 c0.547-0.139,1.106-0.323,1.674-0.553c0.547-0.222,1.115,0.022,1.285,0.587l0.919,3.05c0.069,0.228,0.195,0.387,0.35,0.476 l-0.003,0.003l4.31,2.485l-0.754-4.766l1.319-1.037c0.464-0.365,0.811-1.139,0.774-1.728l-0.243-3.875 c-0.037-0.589,0.255-1.422,0.634-1.875c0.668-0.798,1.675-1.225,2.268-2.092c0.333-0.488,0.691-1.281,1.281-1.251l2.618,0.129 c0.59,0.029,1.263-0.384,1.504-0.924l2.462-5.519c0.241-0.539-0.005-1.164-0.548-1.396l-2.115-0.902 c-0.543-0.232-0.857-0.882-0.726-1.458c0.202-0.887,0.354-1.768,0.453-2.632c0.067-0.587,0.447-1.388,0.882-1.788l3.609-3.318 c0.309-0.284,0.527-0.767,0.597-1.232l3.278-2.556L295.983,189.592z M279.596,215.042c-4.414,3.471-8.64,2.525-9.439-2.111 c-0.798-4.636,2.814-10.528,7.228-13.998c4.414-3.471,7.959-3.207,8.757,1.43C286.941,204.999,284.01,211.572,279.596,215.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M291.042,197.725l-5.323-2.585l-1.236,2.024c0.812,0.596,1.393,1.647,1.66,3.199 c0.798,4.636-2.133,11.208-6.547,14.679c-2.643,2.078-5.213,2.562-7.025,1.629l-0.473,0.774c0,0,3.034,4.611,6.791,3.749 c1.579-0.362,3.439-1.328,5.196-2.659c0.059-0.54,0.301-1.164,0.612-1.537c0.668-0.798,1.676-1.225,2.268-2.092 c0.333-0.488,0.691-1.281,1.281-1.252l0.397,0.02c0.442-0.7,0.822-1.418,1.101-2.146 C291.492,206.974,291.042,197.725,291.042,197.725z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3654_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3732_",
    style: {
      fill: "#5f95fa"
    },
    d: "M263.484,214.166l-3.568,3.281c-0.263,0.242-0.453,0.631-0.551,1.028l5.3,3.06 l0.003-0.282c0.493-0.325,1.109-0.157,1.447,0.326c0.001,0.002,0.003,0.004,0.005,0.006l5.107-2.949L263.484,214.166z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3729_",
    style: {
      fill: "#5f95fa"
    },
    d: "M272.576,204.233c0.402-0.623,0.842-1.23,1.313-1.815l-5.086-2.938 c-0.25,0.103-0.509,0.171-0.748,0.159l-2.618-0.129c-0.372-0.018-0.776,0.14-1.085,0.394l7.829,4.52L272.576,204.233z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3728_",
    style: {
      fill: "#5f95fa"
    },
    d: "M300.26,192.057c-0.2-0.114-0.463-0.093-0.734,0.086l-3.607,2.374 c-0.492,0.321-1.105,0.157-1.447-0.328c-0.221-0.314-0.449-0.599-0.706-0.862c-0.406-0.428-0.627-1.162-0.421-1.718l0.342-0.92 l1.547-1.019c0.278-0.178,0.549-0.192,0.748-0.071v-0.007L300.26,192.057z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3661_",
    style: {
      fill: "#5f95fa"
    },
    d: "M289.601,191.001c-0.042-0.046-0.077-0.102-0.12-0.147 c-0.407-0.428-0.628-1.163-0.423-1.717l5.73-3.632l-4.278-2.469l-0.003,0.004c-0.086-0.049-0.178-0.091-0.283-0.114 l-2.718-0.608c-0.576-0.129-1.266,0.191-1.54,0.714l-2.556,4.87c-0.123,0.235-0.339,0.46-0.583,0.654l5.774,3.334 L289.601,191.001z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3658_",
    style: {
      fill: "#5f95fa"
    },
    d: "M272.098,189.885l5.302,3.061l4.358-3.994 c0.123-0.443,0.176-0.976,0.176-0.976l-4.29-2.476l0.001,0.005c-0.23-0.134-0.525-0.109-0.804,0.11l-4.073,3.202 C272.466,189.054,272.227,189.465,272.098,189.885z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3641_",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3652_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.484,214.166l-3.568,3.281c-0.263,0.242-0.453,0.631-0.551,1.028l5.3,3.06l0.003-0.282 c0.493-0.325,1.109-0.157,1.447,0.326c0.001,0.002,0.003,0.004,0.005,0.006l5.107-2.949L263.484,214.166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.221,220.665c0.353,0,0.703,0.133,0.985,0.387l4.181-2.414l-6.846-3.952l-3.341,3.072 c-0.128,0.118-0.246,0.304-0.333,0.523l4.557,2.631l0.013-0.008C264.682,220.742,264.953,220.665,265.221,220.665z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3647_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.576,204.233c0.402-0.623,0.842-1.23,1.313-1.815l-5.086-2.938 c-0.25,0.103-0.509,0.171-0.748,0.159l-2.618-0.129c-0.372-0.018-0.776,0.14-1.085,0.394l7.829,4.52L272.576,204.233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M265.253,199.938l6.946,4.01l0.089-0.043c0.302-0.461,0.627-0.919,0.971-1.366l-4.494-2.597 c-0.265,0.089-0.506,0.126-0.729,0.116l-2.619-0.129C265.364,199.926,265.308,199.93,265.253,199.938z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3644_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.26,192.057c-0.2-0.114-0.463-0.093-0.734,0.086l-3.607,2.374 c-0.492,0.321-1.105,0.157-1.447-0.328c-0.221-0.314-0.449-0.599-0.706-0.862c-0.406-0.428-0.627-1.162-0.421-1.718 l0.342-0.92l1.547-1.019c0.278-0.178,0.549-0.192,0.748-0.071v-0.007L300.26,192.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.034,190.964l-0.294,0.79c-0.137,0.37,0.012,0.945,0.332,1.282 c0.252,0.259,0.498,0.558,0.745,0.91c0.189,0.267,0.55,0.427,0.873,0.218l3.449-2.269l-2.734-1.577v0.019l-0.639-0.381 c-0.064-0.038-0.18-0.013-0.304,0.066L294.034,190.964z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3643_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.601,191.001c-0.042-0.046-0.077-0.102-0.12-0.147c-0.407-0.428-0.628-1.163-0.423-1.717 l5.73-3.632l-4.278-2.469l-0.003,0.004c-0.086-0.049-0.178-0.091-0.283-0.114l-2.718-0.608 c-0.576-0.129-1.266,0.191-1.54,0.714l-2.556,4.87c-0.123,0.235-0.339,0.46-0.583,0.654l5.774,3.334L289.601,191.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.525,188.472l5.024,2.901l0.471-0.418c-0.434-0.597-0.575-1.37-0.355-1.964l0.049-0.133 l5.263-3.336l-3.678-2.117c-0.062-0.035-0.115-0.057-0.166-0.069l-2.717-0.608c-0.385-0.087-0.891,0.146-1.076,0.499 l-2.556,4.87C283.718,188.223,283.631,188.348,283.525,188.472z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3642_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.098,189.885l5.302,3.061l4.358-3.994c0.123-0.443,0.176-0.976,0.176-0.976l-4.29-2.476 l0.001,0.005c-0.23-0.134-0.525-0.109-0.804,0.11l-4.073,3.202C272.466,189.054,272.227,189.465,272.098,189.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.62,189.701l4.723,2.727l4.039-3.701c0.044-0.184,0.077-0.377,0.099-0.526l-3.19-1.841 l0.002,0.008l-0.861-0.5c-0.117-0.068-0.258,0.02-0.332,0.078l-4.073,3.202C272.876,189.267,272.731,189.466,272.62,189.701z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3604_",
    style: {
      fill: "#5f95fa"
    },
    d: "M301.277,196.544l-0.678-3.936c-0.1-0.582-0.581-0.791-1.075-0.466 l-3.606,2.373c-0.493,0.325-1.109,0.157-1.447-0.326c-0.218-0.311-0.453-0.598-0.703-0.861 c-0.407-0.428-0.627-1.164-0.423-1.717l1.839-4.974c0.205-0.554-0.096-1.107-0.673-1.236l-2.718-0.608 c-0.576-0.129-1.266,0.191-1.54,0.713l-2.555,4.87c-0.274,0.523-0.972,1.016-1.544,1.161c-0.547,0.139-1.106,0.323-1.674,0.553 c-0.547,0.221-1.115-0.022-1.285-0.587l-0.919-3.05c-0.17-0.565-0.685-0.728-1.149-0.363l-4.073,3.202 c-0.464,0.365-0.811,1.138-0.774,1.728l0.243,3.875c0.037,0.589-0.255,1.422-0.634,1.875c-0.667,0.798-1.299,1.636-1.891,2.503 c-0.333,0.488-1.067,0.869-1.657,0.84l-2.618-0.129c-0.59-0.029-1.263,0.384-1.504,0.924l-2.462,5.519 c-0.241,0.539,0.005,1.164,0.548,1.396l2.115,0.902c0.543,0.232,0.857,0.882,0.726,1.458c-0.202,0.887-0.354,1.768-0.453,2.633 c-0.067,0.587-0.448,1.389-0.882,1.788l-3.609,3.318c-0.435,0.4-0.706,1.195-0.606,1.777l0.678,3.936 c0.1,0.582,0.581,0.791,1.075,0.466l3.606-2.373c0.493-0.325,1.109-0.157,1.448,0.326c0.218,0.311,0.452,0.598,0.703,0.861 c0.407,0.428,0.627,1.164,0.423,1.718l-1.839,4.974c-0.205,0.554,0.096,1.107,0.673,1.236l2.717,0.608 c0.576,0.129,1.266-0.191,1.541-0.714l2.556-4.87c0.274-0.523,0.972-1.016,1.544-1.161c0.547-0.139,1.106-0.323,1.674-0.553 c0.547-0.222,1.115,0.022,1.285,0.587l0.919,3.05c0.17,0.565,0.685,0.728,1.149,0.363l4.073-3.202 c0.464-0.365,0.81-1.139,0.774-1.728l-0.243-3.875c-0.037-0.589,0.255-1.422,0.634-1.875c0.668-0.798,1.299-1.636,1.891-2.503 c0.333-0.488,1.067-0.869,1.657-0.84l2.618,0.129c0.59,0.029,1.263-0.384,1.504-0.924l2.462-5.519 c0.24-0.539-0.005-1.164-0.548-1.396l-2.116-0.902c-0.543-0.232-0.857-0.882-0.726-1.458c0.202-0.887,0.354-1.768,0.453-2.633 c0.067-0.587,0.447-1.388,0.882-1.788l3.609-3.318C301.107,197.921,301.378,197.126,301.277,196.544z M283.883,217.516 c-4.414,3.471-8.64,2.525-9.439-2.111c-0.798-4.636,2.133-11.208,6.547-14.678c4.414-3.471,8.64-2.526,9.438,2.11 C291.229,207.473,288.298,214.046,283.883,217.516z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3596_",
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M301.277,196.544l-0.678-3.936c-0.1-0.582-0.581-0.791-1.075-0.466l-3.606,2.373 c-0.493,0.325-1.109,0.157-1.447-0.326c-0.218-0.311-0.453-0.598-0.703-0.861c-0.407-0.428-0.627-1.164-0.423-1.717 l1.839-4.974c0.205-0.554-0.096-1.107-0.673-1.236l-2.718-0.608c-0.576-0.129-1.266,0.191-1.54,0.713l-2.555,4.87 c-0.274,0.523-0.972,1.016-1.544,1.161c-0.547,0.139-1.106,0.323-1.674,0.553c-0.547,0.221-1.115-0.022-1.285-0.587 l-0.919-3.05c-0.17-0.565-0.685-0.728-1.149-0.363l-4.073,3.202c-0.464,0.365-0.811,1.138-0.774,1.728l0.243,3.875 c0.037,0.589-0.255,1.422-0.634,1.875c-0.667,0.798-1.299,1.636-1.891,2.503c-0.333,0.488-1.067,0.869-1.657,0.84l-2.618-0.129 c-0.59-0.029-1.263,0.384-1.504,0.924l-2.462,5.519c-0.241,0.539,0.005,1.164,0.548,1.396l2.115,0.902 c0.543,0.232,0.857,0.882,0.726,1.458c-0.202,0.887-0.354,1.768-0.453,2.633c-0.067,0.587-0.448,1.389-0.882,1.788 l-3.609,3.318c-0.435,0.4-0.706,1.195-0.606,1.777l0.678,3.936c0.1,0.582,0.581,0.791,1.075,0.466l3.606-2.373 c0.493-0.325,1.109-0.157,1.448,0.326c0.218,0.311,0.452,0.598,0.703,0.861c0.407,0.428,0.627,1.164,0.423,1.718l-1.839,4.974 c-0.205,0.554,0.096,1.107,0.673,1.236l2.717,0.608c0.576,0.129,1.266-0.191,1.541-0.714l2.556-4.87 c0.274-0.523,0.972-1.016,1.544-1.161c0.547-0.139,1.106-0.323,1.674-0.553c0.547-0.222,1.115,0.022,1.285,0.587l0.919,3.05 c0.17,0.565,0.685,0.728,1.149,0.363l4.073-3.202c0.464-0.365,0.81-1.139,0.774-1.728l-0.243-3.875 c-0.037-0.589,0.255-1.422,0.634-1.875c0.668-0.798,1.299-1.636,1.891-2.503c0.333-0.488,1.067-0.869,1.657-0.84l2.618,0.129 c0.59,0.029,1.263-0.384,1.504-0.924l2.462-5.519c0.24-0.539-0.005-1.164-0.548-1.396l-2.116-0.902 c-0.543-0.232-0.857-0.882-0.726-1.458c0.202-0.887,0.354-1.768,0.453-2.633c0.067-0.587,0.447-1.388,0.882-1.788l3.609-3.318 C301.107,197.921,301.378,197.126,301.277,196.544z M283.883,217.516c-4.414,3.471-8.64,2.525-9.439-2.111 c-0.798-4.636,2.133-11.208,6.547-14.678c4.414-3.471,8.64-2.526,9.438,2.11C291.229,207.473,288.298,214.046,283.883,217.516z "
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M278.807,220.028c1.651,0,3.516-0.75,5.337-2.181c4.516-3.551,7.522-10.316,6.702-15.081 c-0.365-2.12-1.45-3.627-3.054-4.244c-1.995-0.767-4.567-0.084-7.058,1.874c-4.516,3.55-7.522,10.315-6.702,15.081 c0.365,2.12,1.45,3.627,3.055,4.244C277.622,219.927,278.2,220.028,278.807,220.028z M274.445,215.405 c-0.798-4.636,2.133-11.208,6.547-14.678c4.414-3.471,8.64-2.526,9.438,2.11c0.798,4.637-2.133,11.208-6.547,14.679 C279.469,220.987,275.243,220.042,274.445,215.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M273.08,233.45c0.576,0.129,1.266-0.19,1.541-0.713l2.556-4.87 c0.274-0.523,0.972-1.015,1.544-1.161c0.547-0.139,1.106-0.323,1.674-0.553c0.547-0.222,1.115,0.022,1.285,0.587l0.919,3.05 c0.17,0.565,0.685,0.728,1.149,0.363l4.073-3.202c0.464-0.365,0.81-1.139,0.774-1.728l-0.243-3.875 c-0.037-0.589,0.255-1.422,0.634-1.875c0.668-0.798,1.299-1.636,1.892-2.503c0.333-0.488,1.067-0.869,1.657-0.84l2.618,0.129 c0.59,0.029,1.263-0.384,1.504-0.924l2.462-5.519c0.24-0.539-0.005-1.164-0.548-1.396l-2.115-0.902 c-0.543-0.232-0.857-0.882-0.726-1.458c0.202-0.887,0.354-1.768,0.453-2.633c0.067-0.587,0.447-1.388,0.882-1.788l3.609-3.318 c0.435-0.4,0.706-1.196,0.606-1.778l-0.678-3.936c-0.1-0.582-0.581-0.791-1.075-0.466l-3.606,2.373 c-0.493,0.324-1.109,0.157-1.447-0.327c-0.218-0.311-0.453-0.598-0.703-0.861c-0.407-0.428-0.627-1.164-0.423-1.717 l1.839-4.974c0.205-0.554-0.096-1.107-0.673-1.236l-2.718-0.608c-0.576-0.129-1.266,0.191-1.54,0.713l-2.555,4.87 c-0.275,0.523-0.972,1.016-1.544,1.161c-0.547,0.139-1.106,0.323-1.674,0.553c-0.547,0.221-1.115-0.022-1.285-0.587 l-0.919-3.05c-0.17-0.565-0.685-0.728-1.149-0.363l-4.073,3.202c-0.464,0.365-0.811,1.138-0.774,1.728l0.243,3.875 c0.037,0.589-0.255,1.422-0.634,1.875c-0.667,0.798-1.299,1.636-1.891,2.503c-0.333,0.488-1.067,0.869-1.657,0.84l-2.618-0.129 c-0.59-0.029-1.263,0.384-1.504,0.924l-2.462,5.519c-0.241,0.539,0.005,1.164,0.548,1.396l2.115,0.902 c0.543,0.231,0.857,0.882,0.726,1.458c-0.202,0.887-0.354,1.768-0.453,2.633c-0.067,0.587-0.448,1.389-0.882,1.788 l-3.609,3.318c-0.435,0.4-0.706,1.195-0.606,1.777l0.678,3.936c0.1,0.582,0.581,0.791,1.075,0.466l3.606-2.373 c0.493-0.325,1.109-0.157,1.448,0.326c0.218,0.311,0.452,0.598,0.703,0.861c0.407,0.428,0.627,1.164,0.423,1.718l-1.839,4.974 c-0.205,0.554,0.096,1.107,0.673,1.236L273.08,233.45z M270.103,232.184c-0.069-0.126-0.075-0.279-0.019-0.432l1.839-4.973 c0.249-0.674,0.034-1.579-0.512-2.153c-0.236-0.249-0.459-0.521-0.663-0.812c-0.307-0.439-0.771-0.675-1.24-0.675 c-0.269,0-0.539,0.077-0.783,0.238l-3.606,2.373c-0.112,0.073-0.219,0.102-0.287,0.072c-0.066-0.029-0.12-0.126-0.143-0.259 l-0.678-3.936c-0.076-0.441,0.146-1.094,0.476-1.397l3.609-3.318c0.497-0.457,0.934-1.338,1.015-2.05 c0.097-0.84,0.247-1.711,0.445-2.587c0.177-0.778-0.249-1.63-0.971-1.938l-2.115-0.902c-0.158-0.067-0.279-0.191-0.341-0.349 c-0.062-0.158-0.058-0.331,0.012-0.489l2.462-5.519c0.17-0.38,0.671-0.711,1.099-0.675l2.618,0.129 c0.739,0.03,1.603-0.404,2.025-1.023c0.589-0.863,1.217-1.694,1.867-2.47c0.46-0.549,0.774-1.482,0.731-2.171l-0.243-3.875 c-0.028-0.451,0.259-1.092,0.614-1.371l4.073-3.202c0.11-0.087,0.217-0.121,0.299-0.097c0.079,0.025,0.147,0.117,0.188,0.251 l0.919,3.049c0.114,0.378,0.363,0.675,0.701,0.838c0.351,0.168,0.758,0.175,1.143,0.018c0.544-0.22,1.089-0.4,1.621-0.535 c0.719-0.183,1.498-0.773,1.812-1.373l2.556-4.869c0.184-0.353,0.682-0.585,1.076-0.499l2.718,0.608 c0.159,0.036,0.284,0.124,0.352,0.25c0.068,0.125,0.075,0.278,0.018,0.431l-1.84,4.974c-0.249,0.675-0.033,1.58,0.513,2.153 c0.238,0.25,0.461,0.523,0.663,0.812c0.484,0.69,1.354,0.879,2.023,0.436l3.606-2.373c0.113-0.074,0.22-0.102,0.286-0.072 c0.066,0.029,0.12,0.125,0.143,0.259l0.678,3.936c0.076,0.441-0.147,1.094-0.476,1.396l-3.609,3.319 c-0.498,0.458-0.934,1.339-1.015,2.05c-0.096,0.836-0.246,1.706-0.445,2.587c-0.177,0.779,0.249,1.63,0.971,1.938l2.115,0.902 c0.159,0.067,0.28,0.192,0.342,0.349c0.062,0.158,0.057,0.331-0.012,0.489l-2.462,5.519c-0.169,0.38-0.682,0.705-1.099,0.675 l-2.618-0.129c-0.74-0.036-1.602,0.404-2.025,1.024c-0.589,0.862-1.216,1.693-1.866,2.47c-0.46,0.55-0.774,1.483-0.731,2.171 l0.243,3.875c0.028,0.451-0.259,1.092-0.614,1.371l-4.073,3.202c-0.11,0.087-0.218,0.122-0.298,0.097 c-0.079-0.025-0.148-0.116-0.188-0.251l-0.919-3.049c-0.114-0.378-0.363-0.675-0.702-0.838 c-0.35-0.168-0.756-0.174-1.143-0.018c-0.54,0.219-1.085,0.399-1.619,0.535c-0.719,0.183-1.498,0.774-1.813,1.373l-2.556,4.87 c-0.185,0.353-0.685,0.587-1.077,0.498l-2.717-0.607C270.296,232.397,270.171,232.308,270.103,232.184z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1117_",
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M153.611,112.239c-0.925,0-1.797-0.225-2.581-0.678c-2.193-1.266-3.45-4.148-3.45-7.908 c0-6.865,4.203-14.876,9.369-17.859l0.719-0.415c-0.148-1.037-0.223-2.133-0.223-3.262c0-10.707,6.547-23.197,14.594-27.844 c3.557-2.053,7.023-2.34,9.76-0.811c2.901,1.621,4.752,5.166,5.189,9.848c2.001-3.161,4.445-5.664,6.983-7.129 c2.881-1.664,5.686-1.877,7.898-0.599c2.643,1.526,4.159,5.022,4.159,9.592c0,0.732-0.039,1.487-0.116,2.255 c1.373-0.711,2.707-0.763,3.78-0.143c1.35,0.779,2.125,2.541,2.125,4.831c0,4.178-2.563,9.055-5.713,10.874l-48.696,28.115 C156.102,111.859,154.812,112.239,153.611,112.239z M177.977,53.412c-1.709,0-3.573,0.556-5.479,1.656 c-7.795,4.5-14.135,16.634-14.135,27.05c0,1.195,0.087,2.349,0.259,3.431c0.029,0.187-0.059,0.374-0.224,0.469l-0.989,0.572 c-4.913,2.837-8.91,10.492-8.91,17.064c0,3.423,1.09,6.016,2.991,7.114c1.509,0.871,3.446,0.708,5.461-0.455l48.696-28.115 c2.897-1.673,5.255-6.194,5.255-10.08c0-1.954-0.607-3.426-1.666-4.037c-0.849-0.49-1.959-0.387-3.13,0.289l0,0l-0.525,0.303 c-0.153,0.089-0.34,0.081-0.485-0.017c-0.145-0.098-0.222-0.27-0.198-0.443c0.143-1.038,0.216-2.06,0.216-3.037 c0-4.233-1.349-7.44-3.7-8.798c-1.914-1.105-4.394-0.894-6.982,0.6c-2.732,1.577-5.363,4.443-7.411,8.069 c-0.101,0.179-0.311,0.269-0.51,0.22c-0.2-0.05-0.342-0.226-0.348-0.432c-0.143-5.089-1.896-8.942-4.809-10.569 C180.334,53.694,179.195,53.412,177.977,53.412z M205.874,67.972h0.009H205.874z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_740_",
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M198.496,106.382c-0.615,0-1.196-0.15-1.72-0.453c-1.443-0.833-2.27-2.713-2.27-5.158 c0-4.405,2.702-9.55,6.023-11.467l0.358-0.207c-0.084-0.635-0.127-1.299-0.127-1.979c0-6.842,4.188-14.825,9.337-17.797 c2.307-1.333,4.564-1.515,6.353-0.515c1.789,1,2.964,3.113,3.323,5.906c1.233-1.841,2.703-3.3,4.227-4.18 c1.881-1.087,3.72-1.221,5.175-0.381c1.729,0.998,2.721,3.268,2.721,6.227c0,0.376-0.016,0.761-0.047,1.152 c0.826-0.351,1.625-0.341,2.286,0.04c0.91,0.525,1.431,1.694,1.431,3.208c0,2.748-1.628,5.84-3.705,7.04l-30.873,17.824 C200.133,106.133,199.286,106.382,198.496,106.382z M213.943,69.087c-1.054,0-2.207,0.345-3.389,1.027 c-4.896,2.826-8.878,10.453-8.878,17.003c0,0.745,0.055,1.468,0.162,2.15c0.03,0.187-0.06,0.373-0.224,0.468l-0.628,0.362 c-3.068,1.771-5.564,6.56-5.564,10.673c0,2.109,0.661,3.7,1.812,4.365c0.914,0.527,2.053,0.428,3.294-0.288l30.873-17.824 c1.79-1.034,3.246-3.835,3.246-6.245c0-1.177-0.355-2.057-0.972-2.414c-0.489-0.283-1.118-0.219-1.816,0.184l0,0l-0.333,0.192 c-0.153,0.088-0.341,0.081-0.485-0.017c-0.145-0.098-0.222-0.27-0.198-0.443c0.089-0.651,0.135-1.291,0.135-1.903 c0-2.622-0.825-4.603-2.262-5.433c-1.161-0.671-2.673-0.535-4.258,0.381c-1.706,0.985-3.352,2.779-4.635,5.052 c-0.101,0.179-0.312,0.266-0.509,0.22c-0.2-0.05-0.342-0.226-0.348-0.432c-0.089-3.166-1.169-5.557-2.963-6.559 C215.383,69.259,214.688,69.087,213.943,69.087z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Big_Cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conection"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M189.725,216.624l-1.375-2.382l105.202-60.719c1.622-0.936,2.63-2.681,2.63-4.554v-8.96h2.75v8.96 c0,2.853-1.535,5.51-4.005,6.937L189.725,216.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_888_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_891_",
    style: {
      fill: "#455A64"
    },
    d: "M300.825,133.306c0-0.483-0.319-0.966-0.957-1.334 c-1.277-0.737-3.346-0.737-4.622,0c-0.638,0.368-0.957,0.851-0.957,1.334l0,0v8.601l0,0c0,0.483,0.319,0.966,0.957,1.334 c1.276,0.737,3.346,0.737,4.622,0c0.638-0.368,0.957-0.851,0.957-1.334l0,0V133.306L300.825,133.306z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_890_",
    style: {
      fill: "#37474F"
    },
    d: "M302.823,124.706c0-0.778-0.514-1.556-1.543-2.15 c-2.057-1.187-5.391-1.187-7.448,0c-1.028,0.594-1.543,1.372-1.543,2.15l0,0v8.454h0.024c-0.069,0.827,0.425,1.666,1.518,2.297 c2.057,1.187,5.391,1.187,7.448,0c1.094-0.631,1.588-1.471,1.518-2.297h0.024V124.706L302.823,124.706z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Cloud_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cloud_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8086_",
    style: {
      opacity: 0.8,
      fill: "#5f95fa"
    },
    d: "M349.091,77.028l0.007-0.013l-0.301-0.174 c-0.061-0.035-0.12-0.074-0.182-0.105l-6.632-3.83c0.002-0.155,0.009-0.311,0.009-0.465c0-8.146-2.742-13.85-7.059-16.25 l0.01-0.003l-12.753-7.366l0.006,0.014c-3.506-2.018-8.073-1.832-13.072,1.054c-2.205,1.273-4.326,2.976-6.309,5 c-0.845-0.864-1.764-1.6-2.756-2.187l0.002-0.001l-12.327-7.091l0.003,0.014c-4.51-2.99-10.55-2.93-17.196,0.907 c-13.956,8.058-25.27,29.675-25.27,48.284c0,2.2,0.163,4.254,0.465,6.162l-1.741,1.005c-8.879,5.126-16.077,18.879-16.077,30.718 l0,0c0,6.537,2.197,11.197,5.658,13.202l-0.008,0.003l12.904,7.451l0.001-0.004c2.802,1.606,6.426,1.479,10.387-0.808 l23.383-13.5l62.283-35.959c5.327-3.076,9.646-11.328,9.646-18.431v0C352.174,80.936,350.983,78.284,349.091,77.028z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8084_",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M349.091,77.028l0.007-0.013l-0.301-0.174 c-0.061-0.035-0.12-0.074-0.182-0.105l-6.632-3.83c0.002-0.155,0.009-0.311,0.009-0.465c0-8.146-2.742-13.85-7.059-16.25 l0.01-0.003l-12.753-7.366l0.006,0.014c-3.506-2.018-8.073-1.832-13.072,1.054c-2.205,1.273-4.326,2.976-6.309,5 c-0.845-0.864-1.764-1.6-2.756-2.187l0.002-0.001l-12.327-7.091l0.003,0.014c-4.51-2.99-10.55-2.93-17.196,0.907 c-13.956,8.058-25.27,29.675-25.27,48.284c0,2.2,0.163,4.254,0.465,6.162l-1.741,1.005c-8.879,5.126-16.077,18.879-16.077,30.718 l0,0c0,6.537,2.197,11.197,5.658,13.202l-0.008,0.003l12.904,7.451l0.001-0.004c2.802,1.606,6.426,1.479,10.387-0.808 l23.383-13.5l62.283-35.959c5.327-3.076,9.646-11.328,9.646-18.431v0C352.174,80.936,350.983,78.284,349.091,77.028z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8082_",
    style: {
      opacity: 0.35,
      fill: "#FFFFFF"
    },
    d: "M334.944,56.187h-0.013c-3.485-1.943-8.01-1.719-12.944,1.133 c-2.319,1.344-4.545,3.155-6.614,5.316l-11.693-6.792l-1.146-0.665c0.092-0.099,0.191-0.198,0.283-0.29 c1.983-2.022,4.104-3.722,6.304-5c5-2.885,9.572-3.07,13.076-1.054l-0.007-0.013L334.944,56.187z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8080_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M302.818,54.889c0.303,0.303,0.586,0.619,0.863,0.955l-1.146-0.665 C302.627,55.08,302.726,54.981,302.818,54.889z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8078_",
    style: {
      opacity: 0.35,
      fill: "#FFFFFF"
    },
    d: "M299.748,52.524l-0.007,0.007c-4.4-2.45-10.105-2.167-16.337,1.429 c-6.33,3.656-12.121,10.105-16.554,17.799l-12.859-7.424c4.433-7.694,10.217-14.143,16.548-17.805 c6.647-3.834,12.687-3.893,17.2-0.903l-0.007-0.013L299.748,52.524z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8076_",
    style: {
      opacity: 0.35,
      fill: "#FFFFFF"
    },
    d: "M258.603,108.411l-1.746,1.001 c-6.014,3.472-11.264,10.915-14.011,19.038l-12.865-7.431c2.194-6.476,5.975-12.509,10.467-16.455l5.29-3.584L258.603,108.411z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8075_",
    style: {
      fill: "#5f95fa"
    },
    d: "M342.527,77.362l-0.923,0.533c0.252-1.837,0.387-3.663,0.387-5.454 c0-14.729-8.955-21.499-20.002-15.121c-5.124,2.958-9.796,8.228-13.335,14.496c-0.499-17.734-11.608-25.729-25.247-17.854 c-13.957,8.058-25.271,29.675-25.271,48.284c0,2.2,0.163,4.254,0.465,6.162l-1.741,1.005 c-8.879,5.126-16.077,18.879-16.077,30.718l0,0c0,11.839,7.198,17.539,16.077,12.413l23.383-13.5l0,0l62.283-35.959 c5.327-3.076,9.646-11.328,9.646-18.431v0C352.174,77.551,347.855,74.286,342.527,77.362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8073_",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M342.527,77.362l-0.923,0.533c0.252-1.837,0.387-3.663,0.387-5.454 c0-14.729-8.955-21.499-20.002-15.121c-5.124,2.958-9.796,8.228-13.335,14.496c-0.499-17.734-11.608-25.729-25.247-17.854 c-13.957,8.058-25.271,29.675-25.271,48.284c0,2.2,0.163,4.254,0.465,6.162l-1.741,1.005 c-8.879,5.126-16.077,18.879-16.077,30.718l0,0c0,11.839,7.198,17.539,16.077,12.413l23.383-13.5l0,0l62.283-35.959 c5.327-3.076,9.646-11.328,9.646-18.431v0C352.174,77.551,347.855,74.286,342.527,77.362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8068_",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M250.596,151.139c-3.96-0.001-6.519-4.321-6.519-11.008 c0-10.589,6.609-23.35,14.43-27.866l1.742-1.006c1.181-0.682,1.819-2.021,1.606-3.367l0,0c-0.282-1.778-0.425-3.678-0.425-5.646 c0-17.531,10.597-37.911,23.623-45.432c2.977-1.719,5.797-2.59,8.382-2.59c7.049,0,11.619,6.777,11.925,17.685v0 c0.094,3.336,4.519,4.433,6.16,1.527l0,0c3.388-5.998,7.69-10.709,12.114-13.264c2.252-1.299,4.369-1.959,6.294-1.959 c5.326,0,8.767,5.584,8.767,14.228c0,1.6-0.12,3.284-0.356,5.006l0,0c-0.372,2.714,2.538,4.67,4.91,3.3l0.922-0.533 c0.812-0.468,1.566-0.716,2.183-0.716c1.743,0,2.523,2.589,2.523,5.156c0,5.941-3.664,13.075-8,15.579l-85.666,49.459 C253.551,150.652,251.998,151.139,250.596,151.139C250.597,151.139,250.597,151.139,250.596,151.139z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Server_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Server_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28175_",
    style: {
      fill: "#5f95fa"
    },
    d: "M122.649,108.142l69.924,40.37c1.292,0.746,2.339,2.56,2.339,4.051V374.73 c0,1.491-1.047,3.305-2.339,4.051l-75.632,43.666c-1.292,0.746-3.386,0.746-4.678,0l-69.922-40.37 c-1.292-0.746-2.339-2.56-2.339-4.051V155.86c0-1.492,1.047-3.305,2.339-4.051l75.63-43.666 C119.263,107.396,121.358,107.396,122.649,108.142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1022_",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M122.649,108.142l69.924,40.37c1.292,0.746,2.339,2.56,2.339,4.051 V374.73c0,1.491-1.047,3.305-2.339,4.051l-75.632,43.666c-1.292,0.746-3.386,0.746-4.678,0l-69.922-40.37 c-1.292-0.746-2.339-2.56-2.339-4.051V155.86c0-1.492,1.047-3.305,2.339-4.051l75.63-43.666 C119.263,107.396,121.358,107.396,122.649,108.142z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28174_",
    style: {
      fill: "#5f95fa"
    },
    d: "M40.005,155.856v222.169c0,1.491,1.048,3.306,2.334,4.051l69.929,40.371 c0.637,0.378,1.491,0.562,2.333,0.562V195.438c-0.842,0-1.685-0.194-2.333-0.562l-69.929-40.371l-0.638-0.529l-0.832-0.691 C40.34,154.084,40.005,155.013,40.005,155.856z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28088_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M40.005,155.856v222.169c0,1.491,1.048,3.306,2.334,4.051 l69.929,40.371c0.637,0.378,1.491,0.562,2.333,0.562V195.438c-0.842,0-1.685-0.194-2.333-0.562l-69.929-40.371l-0.638-0.529 l-0.832-0.691C40.34,154.084,40.005,155.013,40.005,155.856z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28080_",
    style: {
      fill: "#5f95fa"
    },
    d: "M42.341,151.809l75.631-43.666c1.292-0.746,3.386-0.746,4.678,0l69.923,40.37 c1.292,0.746,1.292,1.955,0,2.701l-75.632,43.666c-1.292,0.746-3.386,0.746-4.678,0l-69.922-40.37 C41.049,153.764,41.049,152.554,42.341,151.809z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28153_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M42.341,151.809l75.631-43.666c1.292-0.746,3.386-0.746,4.678,0 l69.923,40.37c1.292,0.746,1.292,1.955,0,2.701l-75.632,43.666c-1.292,0.746-3.386,0.746-4.678,0l-69.922-40.37 C41.049,153.764,41.049,152.554,42.341,151.809z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28129_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28163_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M125.045,310.402c-0.301,0-0.585-0.073-0.837-0.219c-0.59-0.34-0.915-1.02-0.915-1.911v-19.935 c-0.001-1.663,1.127-3.616,2.568-4.448l58.079-33.532c0.772-0.448,1.523-0.505,2.113-0.164c0.589,0.34,0.914,1.019,0.914,1.911 l-0.001,19.934c0,1.663-1.128,3.617-2.569,4.448l-58.077,33.533C125.88,310.274,125.446,310.402,125.045,310.402z  M184.398,251.151l-58.079,33.532c-1.144,0.661-2.11,2.334-2.109,3.655v19.935c0,0.543,0.167,0.95,0.457,1.117 c0.287,0.167,0.724,0.108,1.195-0.163l58.077-33.533c1.144-0.661,2.11-2.334,2.11-3.655l0.001-19.934 c0-0.543-0.166-0.95-0.456-1.117C185.304,250.821,184.868,250.88,184.398,251.151L184.398,251.151z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28132_",
    style: {
      fill: "#5f95fa"
    },
    d: "M182.119,259.538c0,1.399-1.047,3.138-2.339,3.884l-49.302,28.465 c-1.292,0.746-2.339,0.216-2.339-1.183s1.047-3.138,2.339-3.884l49.302-28.465C181.072,257.609,182.119,258.139,182.119,259.538z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28131_",
    style: {
      fill: "#263238"
    },
    d: "M182.119,269.673c0,1.399-1.047,3.138-2.339,3.884l-49.302,28.465 c-1.292,0.746-2.339,0.216-2.339-1.183s1.047-3.138,2.339-3.884l49.302-28.465C181.072,267.744,182.119,268.273,182.119,269.673z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28130_",
    style: {
      fill: "#5f95fa"
    },
    d: "M179.781,268.49l-20.923,12.08l0,5.067l20.923-12.079 c1.292-0.746,2.339-2.485,2.339-3.884C182.119,268.273,181.072,267.744,179.781,268.49z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28104_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28118_",
    style: {
      fill: "#5f95fa"
    },
    d: "M103.632,199.125c-2.424-1.405-4.389-0.126-4.389,2.858l0,117.585 c0,2.983,1.965,6.541,4.388,7.946s4.388,0.126,4.388-2.858l0.001-117.585C108.021,204.087,106.056,200.53,103.632,199.125z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28117_",
    style: {
      fill: "#37474F"
    },
    d: "M103.632,324.948c-1.212-0.7-2.194-2.476-2.194-3.967l0.001-117.909 c0-1.492,0.982-2.134,2.194-1.434c1.212,0.699,2.194,2.476,2.194,3.967l-0.001,117.909 C105.826,325.006,104.843,325.648,103.632,324.948z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28116_",
    style: {
      fill: "#5f95fa"
    },
    d: "M103.632,324.948c-1.212-0.7-2.194-2.476-2.194-3.967l0.001-62.903l4.389,2.534 l-0.001,62.903C105.826,325.006,104.843,325.648,103.632,324.948z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1037_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M103.632,324.948c-1.212-0.7-2.194-2.476-2.194-3.967l0.001-62.903 l4.389,2.534l-0.001,62.903C105.826,325.006,104.843,325.648,103.632,324.948z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28115_",
    style: {
      fill: "#5f95fa"
    },
    d: "M90.467,191.525c-2.424-1.405-4.388-0.126-4.388,2.858l0,117.585 c0,2.983,1.965,6.541,4.388,7.946c2.424,1.405,4.388,0.126,4.388-2.857l0.001-117.585 C94.856,196.487,92.891,192.93,90.467,191.525z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28114_",
    style: {
      fill: "#5f95fa"
    },
    d: "M90.466,317.348c-1.212-0.699-2.194-2.476-2.194-3.967l0.001-117.909 c0-1.492,0.982-2.134,2.194-1.434c1.212,0.7,2.194,2.476,2.194,3.968l-0.001,117.909 C92.661,317.405,91.678,318.047,90.466,317.348z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1044_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M90.466,317.348c-1.212-0.699-2.194-2.476-2.194-3.967 l0.001-117.909c0-1.492,0.982-2.134,2.194-1.434c1.212,0.7,2.194,2.476,2.194,3.968l-0.001,117.909 C92.661,317.405,91.678,318.047,90.466,317.348z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28113_",
    style: {
      fill: "#5f95fa"
    },
    d: "M77.302,183.924c-2.424-1.405-4.389-0.126-4.389,2.858l0,117.585 c0,2.983,1.965,6.541,4.388,7.946c2.424,1.405,4.388,0.126,4.388-2.858L81.69,191.87 C81.691,188.887,79.726,185.329,77.302,183.924z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28112_",
    style: {
      fill: "#37474F"
    },
    d: "M77.301,309.747c-1.212-0.7-2.194-2.476-2.194-3.968l0.001-117.909 c0-1.492,0.982-2.134,2.194-1.434c1.212,0.7,2.194,2.476,2.194,3.967l-0.001,117.909 C79.496,309.805,78.513,310.447,77.301,309.747z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28111_",
    style: {
      fill: "#5f95fa"
    },
    d: "M77.301,309.747c-1.212-0.7-2.194-2.476-2.194-3.968l0.001-88.45l4.389,2.533 l-0.001,88.45C79.496,309.805,78.513,310.447,77.301,309.747z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1052_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M77.301,309.747c-1.212-0.7-2.194-2.476-2.194-3.968l0.001-88.45 l4.389,2.533l-0.001,88.45C79.496,309.805,78.513,310.447,77.301,309.747z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28110_",
    style: {
      fill: "#5f95fa"
    },
    d: "M64.137,176.324c-2.424-1.405-4.389-0.126-4.389,2.858l0,117.585 c0,2.983,1.965,6.541,4.388,7.946c2.424,1.405,4.388,0.126,4.388-2.858l0.001-117.585 C68.526,181.286,66.561,177.729,64.137,176.324z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28109_",
    style: {
      fill: "#37474F"
    },
    d: "M64.136,302.147c-1.212-0.699-2.194-2.476-2.194-3.968l0.001-117.909 c0-1.491,0.982-2.134,2.194-1.434c1.212,0.7,2.194,2.476,2.194,3.968l-0.001,117.909 C66.331,302.204,65.348,302.846,64.136,302.147z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28108_",
    style: {
      fill: "#5f95fa"
    },
    d: "M64.136,302.147c-1.212-0.699-2.194-2.476-2.194-3.968l0-25.27l4.389,2.533 l-0.001,25.27C66.331,302.204,65.348,302.846,64.136,302.147z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1068_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M64.136,302.147c-1.212-0.699-2.194-2.476-2.194-3.968l0-25.27 l4.389,2.533l-0.001,25.27C66.331,302.204,65.348,302.846,64.136,302.147z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28107_",
    style: {
      fill: "#5f95fa"
    },
    d: "M50.972,168.723c-2.424-1.405-4.389-0.125-4.389,2.858l-0.001,117.585 c0,2.983,1.965,6.541,4.388,7.946c2.424,1.405,4.388,0.126,4.388-2.857l0.001-117.585 C55.361,173.686,53.396,170.129,50.972,168.723z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28106_",
    style: {
      fill: "#37474F"
    },
    d: "M50.971,294.546c-1.212-0.699-2.194-2.476-2.194-3.967l0.001-117.909 c0-1.492,0.982-2.134,2.194-1.434c1.212,0.7,2.194,2.476,2.194,3.968l-0.001,117.909 C53.166,294.604,52.183,295.246,50.971,294.546z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28105_",
    style: {
      fill: "#5f95fa"
    },
    d: "M50.971,294.546c-1.212-0.699-2.194-2.476-2.194-3.967l0.001-67.972 l4.389,2.534l-0.001,67.972C53.166,294.604,52.183,295.246,50.971,294.546z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1077_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M50.971,294.546c-1.212-0.699-2.194-2.476-2.194-3.967l0.001-67.972 l4.389,2.534l-0.001,67.972C53.166,294.604,52.183,295.246,50.971,294.546z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28173_",
    style: {
      fill: "#455A64"
    },
    d: "M184.169,165.204l-58.079,33.532c-1.292,0.746-2.339,2.56-2.339,4.051 l0.001,66.803c0,1.492,1.047,2.096,2.339,1.35l58.077-33.532c1.292-0.746,2.339-2.56,2.339-4.051l0.001-66.803 C186.508,165.063,185.461,164.459,184.169,165.204z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M124.387,200.58c-0.391,0.709-0.636,1.494-0.636,2.208l0.001,66.803 c0,1.492,1.047,2.096,2.339,1.35l58.077-33.532c0.672-0.388,1.273-1.066,1.7-1.837L124.387,200.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M126.09,198.736c-1.292,0.746-2.339,2.56-2.339,4.051l0.001,64.205l55.854-32.248 c1.292-0.746,2.339-2.56,2.339-4.051l0.001-64.205L126.09,198.736z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Server"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28314_",
    style: {
      fill: "#37474F"
    },
    d: "M56.228,382.317c0.572,0.33,1.035,1.133,1.035,1.793 c0,0.66-0.464,0.928-1.035,0.598c-0.572-0.33-1.035-1.133-1.035-1.793C55.193,382.255,55.657,381.987,56.228,382.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M64.852,387.306c0.57,0.329,1.032,1.129,1.032,1.787c0,0.658-0.462,0.924-1.031,0.596 c-0.57-0.329-1.032-1.129-1.032-1.787C63.821,387.243,64.282,386.977,64.852,387.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M73.331,392.199c0.568,0.328,1.028,1.125,1.028,1.78c0,0.655-0.46,0.921-1.028,0.593 c-0.568-0.328-1.028-1.125-1.028-1.78C72.303,392.137,72.763,391.872,73.331,392.199z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28313_",
    style: {
      fill: "#37474F"
    },
    d: "M81.883,397.14c0.566,0.327,1.024,1.121,1.024,1.774 c0,0.653-0.458,0.918-1.024,0.591c-0.566-0.327-1.024-1.121-1.024-1.774C80.858,397.078,81.317,396.814,81.883,397.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28299_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28305_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M46.164,331.603l8.765,5.036c1.372,0.793,2.485,2.72,2.485,4.304v5.029 c0,1.585-1.113,2.227-2.485,1.435l-8.765-5.036c-1.372-0.792-2.485-2.72-2.485-4.305v-5.028 C43.679,331.453,44.792,330.811,46.164,331.603z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28300_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28301_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28304_",
    style: {
      fill: "#5f95fa"
    },
    d: "M48.528,337.273l1.139-0.658l0.001-0.001l0.008-0.004l0.001,0.001 c0.39-0.22,0.926-0.187,1.518,0.155c1.193,0.689,2.16,2.364,2.16,3.741c0,0.688-0.241,1.171-0.631,1.397v0l-0.002,0.001l0,0 l-1.06,0.607l-0.191-0.32c-0.197-0.045-0.403-0.116-0.619-0.241c-1.193-0.689-2.16-2.364-2.16-3.741 c0-0.205,0.028-0.385,0.068-0.552L48.528,337.273z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28303_",
    style: {
      opacity: 0.2
    },
    d: "M48.528,337.273l1.139-0.658l0.001-0.001l0.008-0.004l0.001,0.001 c0.39-0.22,0.926-0.187,1.518,0.155c1.193,0.689,2.16,2.364,2.16,3.741c0,0.688-0.241,1.171-0.631,1.397v0l-0.002,0.001l0,0 l-1.06,0.607l-0.191-0.32c-0.197-0.045-0.403-0.116-0.619-0.241c-1.193-0.689-2.16-2.364-2.16-3.741 c0-0.205,0.028-0.385,0.068-0.552L48.528,337.273z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28302_",
    style: {
      fill: "#5f95fa"
    },
    d: "M50.099,337.397c1.193,0.689,2.16,2.364,2.16,3.741 s-0.967,1.936-2.16,1.247c-1.193-0.689-2.16-2.364-2.16-3.741C47.939,337.266,48.906,336.708,50.099,337.397z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28093_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28097_",
    style: {
      fill: "#37474F"
    },
    d: "M64.457,340.267l42.508,24.52c0.761,0.439,1.377,1.507,1.377,2.386l0,11.738 c0,0.878-0.617,1.234-1.377,0.795l-42.507-24.521c-0.761-0.439-1.377-1.507-1.377-2.385l0-11.738 C63.08,340.184,63.696,339.828,64.457,340.267z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28096_",
    style: {
      fill: "#5f95fa"
    },
    d: "M65.664,345.439c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,344.303,65.664,344.615,65.664,345.439z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28095_",
    style: {
      fill: "#263238"
    },
    d: "M65.664,351.407c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287L67.041,350.71 C66.281,350.271,65.664,350.583,65.664,351.407z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28094_",
    style: {
      fill: "#5f95fa"
    },
    d: "M67.041,350.71l25.797,14.873l0,2.983l-25.797-14.872 c-0.761-0.439-1.377-1.463-1.377-2.287C65.664,350.583,66.281,350.271,67.041,350.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28217_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28234_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M141.945,320.038c-0.338,0.001-0.655-0.081-0.939-0.244c-0.663-0.383-1.029-1.151-1.029-2.164 v-5.521c0-1.914,1.299-4.164,2.958-5.122l40.615-23.449c0.876-0.506,1.724-0.576,2.387-0.192 c0.663,0.382,1.029,1.151,1.029,2.163l0.001,5.521c0,1.915-1.299,4.166-2.958,5.122l-40.615,23.449 C142.892,319.892,142.399,320.038,141.945,320.038z M184.996,284.018c-0.292,0-0.628,0.106-0.987,0.313l-40.615,23.449 c-1.355,0.783-2.5,2.765-2.5,4.329v5.521c0,0.671,0.202,1.158,0.57,1.37c0.369,0.214,0.891,0.144,1.471-0.191l40.615-23.449 c1.355-0.783,2.5-2.765,2.5-4.329l-0.001-5.521c0-0.671-0.202-1.157-0.57-1.369 C185.339,284.059,185.176,284.018,184.996,284.018z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28218_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28233_",
    style: {
      fill: "#5f95fa"
    },
    d: "M183.63,288.61v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C183.385,288.121,183.63,288.262,183.63,288.61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28232_",
    style: {
      fill: "#5f95fa"
    },
    d: "M180.872,290.199v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C180.627,289.71,180.872,289.852,180.872,290.199z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28231_",
    style: {
      fill: "#5f95fa"
    },
    d: "M178.114,291.789l0,2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.545,0.033-0.545-0.315v-2.678c0-0.348,0.244-0.771,0.545-0.945l0.614-0.354 C177.87,291.3,178.114,291.441,178.114,291.789z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28230_",
    style: {
      fill: "#5f95fa"
    },
    d: "M175.356,293.379v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C175.112,292.89,175.356,293.031,175.356,293.379z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28229_",
    style: {
      fill: "#37474F"
    },
    d: "M172.598,294.969l0,2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.355 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C172.354,294.48,172.598,294.621,172.598,294.969z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28228_",
    style: {
      fill: "#37474F"
    },
    d: "M169.84,296.559l0,2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.355 C169.596,296.069,169.84,296.211,169.84,296.559z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28227_",
    style: {
      fill: "#5f95fa"
    },
    d: "M167.083,298.148v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.245-0.771,0.546-0.945l0.614-0.354 C166.838,297.659,167.083,297.8,167.083,298.148z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28226_",
    style: {
      fill: "#5f95fa"
    },
    d: "M164.325,299.738v2.678c0,0.348-0.245,0.771-0.546,0.945l-0.614,0.354 c-0.302,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.355 C164.081,299.249,164.325,299.39,164.325,299.738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28225_",
    style: {
      fill: "#5f95fa"
    },
    d: "M161.567,301.328v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.355 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C161.323,300.839,161.567,300.98,161.567,301.328z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28224_",
    style: {
      fill: "#37474F"
    },
    d: "M158.809,302.918v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.355 C158.565,302.429,158.809,302.57,158.809,302.918z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28223_",
    style: {
      fill: "#5f95fa"
    },
    d: "M156.051,304.508l0,2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C155.807,304.019,156.051,304.16,156.051,304.508z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28222_",
    style: {
      fill: "#5f95fa"
    },
    d: "M153.294,306.098v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C153.049,305.608,153.294,305.75,153.294,306.098z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28221_",
    style: {
      fill: "#37474F"
    },
    d: "M150.536,307.687v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C150.291,307.198,150.536,307.339,150.536,307.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28220_",
    style: {
      fill: "#5f95fa"
    },
    d: "M147.778,309.277l0,2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C147.533,308.788,147.778,308.929,147.778,309.277z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28219_",
    style: {
      fill: "#37474F"
    },
    d: "M145.02,310.867v2.678c0,0.348-0.244,0.771-0.546,0.945l-0.614,0.354 c-0.301,0.174-0.546,0.033-0.546-0.315v-2.678c0-0.348,0.244-0.771,0.546-0.945l0.614-0.354 C144.776,310.378,145.02,310.519,145.02,310.867z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28138_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28142_",
    style: {
      fill: "#37474F"
    },
    d: "M136.333,316.233l-1.14-0.658l-0.001-0.001l-0.008-0.005l-0.001,0.001 c-0.39-0.22-0.926-0.187-1.518,0.155c-1.193,0.689-2.16,2.364-2.16,3.741c0,0.688,0.241,1.171,0.631,1.397v0l0.002,0.001l0,0 l1.06,0.607l0.191-0.32c0.197-0.046,0.403-0.116,0.619-0.241c1.193-0.689,2.16-2.364,2.16-3.741 c0-0.204-0.027-0.385-0.068-0.552L136.333,316.233z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28140_",
    style: {
      fill: "#455A64"
    },
    d: "M134.761,316.356c-1.193,0.689-2.16,2.364-2.16,3.741 s0.967,1.936,2.16,1.247c1.193-0.689,2.16-2.364,2.16-3.741C136.921,316.226,135.954,315.667,134.761,316.356z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28133_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28137_",
    style: {
      fill: "#37474F"
    },
    d: "M126.956,321.645l-1.14-0.658l-0.001,0l-0.008-0.005l-0.001,0.001 c-0.39-0.22-0.926-0.187-1.518,0.155c-1.193,0.689-2.16,2.364-2.16,3.741c0,0.688,0.241,1.171,0.631,1.397v0l0.002,0.001l0,0 l1.06,0.607l0.191-0.319c0.197-0.045,0.403-0.116,0.619-0.241c1.193-0.689,2.16-2.364,2.16-3.741 c0-0.205-0.027-0.385-0.068-0.552L126.956,321.645z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28135_",
    style: {
      fill: "#455A64"
    },
    d: "M125.384,321.768c-1.193,0.689-2.16,2.364-2.16,3.741 s0.967,1.936,2.16,1.247c1.193-0.689,2.16-2.364,2.16-3.742C127.544,321.637,126.577,321.079,125.384,321.768z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28098_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28102_",
    style: {
      fill: "#455A64"
    },
    d: "M64.457,315.988l42.508,24.52c0.761,0.439,1.377,1.507,1.377,2.386l0,11.738 c0,0.878-0.617,1.234-1.377,0.795l-42.507-24.521c-0.761-0.439-1.377-1.507-1.377-2.386l0-11.738 C63.08,315.905,63.696,315.549,64.457,315.988z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28101_",
    style: {
      fill: "#5f95fa"
    },
    d: "M65.664,321.161c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,320.025,65.664,320.336,65.664,321.161z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28100_",
    style: {
      fill: "#263238"
    },
    d: "M65.664,327.128c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,325.992,65.664,326.304,65.664,327.128z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28099_",
    style: {
      fill: "#5f95fa"
    },
    d: "M67.041,326.431L87.67,338.32l0,2.983l-20.629-11.888 c-0.761-0.439-1.377-1.463-1.377-2.287C65.664,326.304,66.281,325.992,67.041,326.431z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28037_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28084_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M46.164,307.39l8.765,5.036c1.372,0.792,2.485,2.72,2.485,4.304v5.029 c0,1.585-1.113,2.227-2.485,1.435l-8.765-5.036c-1.372-0.793-2.485-2.72-2.485-4.305v-5.029 C43.679,307.24,44.792,306.598,46.164,307.39z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28038_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28039_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28083_",
    style: {
      fill: "#5f95fa"
    },
    d: "M48.528,313.061l1.139-0.658l0.001-0.001l0.008-0.005l0.001,0.001 c0.39-0.22,0.926-0.187,1.518,0.155c1.193,0.689,2.16,2.364,2.16,3.741c0,0.688-0.241,1.171-0.631,1.397v0l-0.002,0.001l0,0 l-1.06,0.607l-0.191-0.32c-0.197-0.045-0.403-0.116-0.619-0.241c-1.193-0.689-2.16-2.364-2.16-3.741 c0-0.205,0.028-0.385,0.068-0.552L48.528,313.061z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28082_",
    style: {
      opacity: 0.2
    },
    d: "M48.528,313.061l1.139-0.658l0.001-0.001l0.008-0.005l0.001,0.001 c0.39-0.22,0.926-0.187,1.518,0.155c1.193,0.689,2.16,2.364,2.16,3.741c0,0.688-0.241,1.171-0.631,1.397v0l-0.002,0.001l0,0 l-1.06,0.607l-0.191-0.32c-0.197-0.045-0.403-0.116-0.619-0.241c-1.193-0.689-2.16-2.364-2.16-3.741 c0-0.205,0.028-0.385,0.068-0.552L48.528,313.061z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28081_",
    style: {
      fill: "#5f95fa"
    },
    d: "M50.099,313.184c1.193,0.689,2.16,2.364,2.16,3.741 s-0.967,1.936-2.16,1.247c-1.193-0.689-2.16-2.364-2.16-3.741C47.939,313.053,48.906,312.495,50.099,313.184z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28032_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28036_",
    style: {
      fill: "#37474F"
    },
    d: "M64.457,315.988l42.508,24.52c0.761,0.439,1.377,1.507,1.377,2.386l0,11.738 c0,0.878-0.617,1.234-1.377,0.795l-42.507-24.521c-0.761-0.439-1.377-1.507-1.377-2.386l0-11.738 C63.08,315.905,63.696,315.549,64.457,315.988z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28035_",
    style: {
      fill: "#5f95fa"
    },
    d: "M65.664,321.161c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,320.025,65.664,320.336,65.664,321.161z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28034_",
    style: {
      fill: "#263238"
    },
    d: "M65.664,327.128c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,325.992,65.664,326.304,65.664,327.128z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28033_",
    style: {
      fill: "#5f95fa"
    },
    d: "M67.041,326.431L87.67,338.32l0,2.983l-20.629-11.888 c-0.761-0.439-1.377-1.463-1.377-2.287C65.664,326.304,66.281,325.992,67.041,326.431z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28120_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28126_",
    style: {
      fill: "#F5F5F5"
    },
    d: "M46.164,355.955l8.765,5.036c1.372,0.793,2.485,2.719,2.485,4.304v5.029 c0,1.585-1.113,2.227-2.485,1.435l-8.765-5.036c-1.372-0.792-2.485-2.72-2.485-4.304v-5.029 C43.679,355.805,44.792,355.163,46.164,355.955z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28121_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28122_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28125_",
    style: {
      fill: "#5f95fa"
    },
    d: "M48.528,361.626l1.139-0.658l0.001-0.001l0.008-0.005l0.001,0.001 c0.39-0.22,0.926-0.187,1.518,0.155c1.193,0.689,2.16,2.364,2.16,3.741c0,0.688-0.241,1.171-0.631,1.397v0l-0.002,0.001l0,0 l-1.06,0.607l-0.191-0.32c-0.197-0.045-0.403-0.116-0.619-0.241c-1.193-0.689-2.16-2.364-2.16-3.741 c0-0.205,0.028-0.385,0.068-0.552L48.528,361.626z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28124_",
    style: {
      opacity: 0.2
    },
    d: "M48.528,361.626l1.139-0.658l0.001-0.001l0.008-0.005l0.001,0.001 c0.39-0.22,0.926-0.187,1.518,0.155c1.193,0.689,2.16,2.364,2.16,3.741c0,0.688-0.241,1.171-0.631,1.397v0l-0.002,0.001l0,0 l-1.06,0.607l-0.191-0.32c-0.197-0.045-0.403-0.116-0.619-0.241c-1.193-0.689-2.16-2.364-2.16-3.741 c0-0.205,0.028-0.385,0.068-0.552L48.528,361.626z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28123_",
    style: {
      fill: "#5f95fa"
    },
    d: "M50.099,361.749c1.193,0.689,2.16,2.364,2.16,3.741 c0,1.378-0.967,1.936-2.16,1.247c-1.193-0.689-2.16-2.364-2.16-3.741C47.939,361.618,48.906,361.06,50.099,361.749z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28085_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28119_",
    style: {
      fill: "#37474F"
    },
    d: "M64.457,364.553l42.508,24.52c0.761,0.439,1.377,1.507,1.377,2.385l0,11.738 c0,0.878-0.617,1.234-1.377,0.795l-42.507-24.521c-0.761-0.439-1.377-1.507-1.377-2.386l0-11.738 C63.08,364.47,63.696,364.114,64.457,364.553z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28103_",
    style: {
      fill: "#5f95fa"
    },
    d: "M65.664,369.725c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,368.59,65.664,368.901,65.664,369.725z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28087_",
    style: {
      fill: "#263238"
    },
    d: "M65.664,375.693c0,0.824,0.617,1.848,1.377,2.287l37.339,21.537 c0.761,0.439,1.377,0.127,1.377-0.697c0-0.824-0.617-1.848-1.377-2.287l-37.339-21.537 C66.281,374.557,65.664,374.869,65.664,375.693z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28086_",
    style: {
      fill: "#5f95fa"
    },
    d: "M67.041,374.996l20.629,11.889l0,2.983L67.041,377.98 c-0.761-0.439-1.377-1.463-1.377-2.287C65.664,374.869,66.281,374.557,67.041,374.996z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28075_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28152_",
    style: {
      opacity: 0.1
    },
    d: "M174.93,153.554l-56.682,32.725c-0.81,0.468-2.123,0.468-2.933,0l-56.682-32.725 c-0.81-0.468-0.81-1.226,0-1.693l56.682-31.596c0.81-0.467,2.123-0.467,2.933,0l56.682,31.595 C175.74,152.328,175.74,153.086,174.93,153.554z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28078_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.185,184.487l54.241-31.316c0.775-0.447,1.403-1.536,1.403-2.431v-1.826 c0-0.895-0.628-1.983-1.403-2.431l-54.241-31.316c-0.775-0.448-2.032-0.448-2.807,0l-54.241,31.316 c-0.775,0.447-1.403,1.536-1.403,2.431v1.826c0,0.895,0.628,1.983,1.403,2.431l54.241,31.316 C116.153,184.935,117.41,184.935,118.185,184.487z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28149_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M118.185,184.487l54.241-31.316 c0.775-0.447,1.403-1.536,1.403-2.431v-1.826c0-0.895-0.628-1.983-1.403-2.431l-54.241-31.316c-0.775-0.448-2.032-0.448-2.807,0 l-54.241,31.316c-0.775,0.447-1.403,1.536-1.403,2.431v1.826c0,0.895,0.628,1.983,1.403,2.431l54.241,31.316 C116.153,184.935,117.41,184.935,118.185,184.487z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28151_",
    style: {
      opacity: 0.05
    },
    d: "M118.185,184.487l54.241-31.316c0.775-0.447,1.403-1.536,1.403-2.431v-1.826 c0-0.895-0.628-1.983-1.403-2.431l-54.241-31.316c-0.775-0.448-2.032-0.448-2.807,0l-54.241,31.316 c-0.775,0.447-1.403,1.536-1.403,2.431v1.826c0,0.895,0.628,1.983,1.403,2.431l54.241,31.316 C116.153,184.935,117.41,184.935,118.185,184.487z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28077_",
    style: {
      fill: "#5f95fa"
    },
    d: "M172.426,148.104l-54.241,31.316c-0.775,0.447-2.032,0.447-2.807,0 l-54.241-31.316c-0.775-0.447-0.775-1.173,0-1.62l54.241-30.235c0.775-0.448,2.032-0.448,2.807,0l54.241,30.235 C173.201,146.931,173.201,147.656,172.426,148.104z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28150_",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M172.426,148.104l-54.241,31.316c-0.775,0.447-2.032,0.447-2.807,0 l-54.241-31.316c-0.775-0.447-0.775-1.173,0-1.62l54.241-30.235c0.775-0.448,2.032-0.448,2.807,0l54.241,30.235 C173.201,146.931,173.201,147.656,172.426,148.104z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28076_",
    style: {
      fill: "#5f95fa"
    },
    d: "M116.779,179.754v5.067c0.508,0,1.016-0.108,1.404-0.335l54.243-31.318 c0.778-0.443,1.404-1.534,1.404-2.431v-1.826c0-0.789-0.486-1.728-1.145-2.247c0.508,0.443,0.422,1.048-0.259,1.437 l-54.243,31.318C117.795,179.646,117.287,179.754,116.779,179.754z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28148_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M116.779,179.754v5.067c0.508,0,1.016-0.108,1.404-0.335 l54.243-31.318c0.778-0.443,1.404-1.534,1.404-2.431v-1.826c0-0.789-0.486-1.728-1.145-2.247 c0.508,0.443,0.422,1.048-0.259,1.437l-54.243,31.318C117.795,179.646,117.287,179.754,116.779,179.754z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28040_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28074_",
    style: {
      fill: "#263238"
    },
    d: "M118.185,169.286l36.688-21.182c0.775-0.447,1.403-1.536,1.403-2.431v-1.826 c0-0.895-0.628-1.983-1.403-2.431l-23.523-13.58c-0.775-0.447-1.836-1.393-2.369-2.111l-11.234-15.133 c-0.534-0.718-1.594-0.938-2.369-0.491l-36.688,21.181c-0.775,0.448-1.403,1.536-1.403,2.431l0.001,11.961 c0,0.895,0.628,1.983,1.404,2.431l36.688,21.182C116.153,169.733,117.41,169.733,118.185,169.286z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28073_",
    style: {
      fill: "#455A64"
    },
    d: "M115.378,164.219l-23.523-13.581c-0.373-0.215-0.813-0.546-1.228-0.912 c-0.447-0.394-0.865-0.827-1.142-1.2l-11.234-15.133c-0.534-0.719-0.338-1.664,0.437-2.111l36.688-21.181 c0.775-0.448,1.836-0.228,2.369,0.491l11.234,15.133c0.534,0.719,1.4,1.749,2.175,2.196l23.717,13.495 c0.775,0.447,0.775,1.173,0,1.62l-36.688,21.182C117.41,164.666,116.153,164.666,115.378,164.219z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28072_",
    style: {
      fill: "#37474F"
    },
    d: "M78.689,131.281l36.688-21.181c0.775-0.448,1.836-0.228,2.369,0.491 l11.234,15.133c0.278,0.374,0.699,0.802,1.148,1.195c0,0-39.487,22.813-39.499,22.803c-0.448-0.394-0.868-0.824-1.144-1.197 l-11.234-15.133C77.718,132.674,77.914,131.729,78.689,131.281z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28051_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28071_",
    style: {
      fill: "#5f95fa"
    },
    d: "M145.971,141.788c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C146.88,143.164,146.88,142.313,145.971,141.788z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28070_",
    style: {
      fill: "#5f95fa"
    },
    d: "M139.389,145.588c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C140.298,146.964,140.298,146.113,139.389,145.588z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28069_",
    style: {
      fill: "#263238"
    },
    d: "M132.807,149.389c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C133.716,150.764,133.716,149.913,132.807,149.389z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28068_",
    style: {
      fill: "#263238"
    },
    d: "M126.225,153.189c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C127.134,154.564,127.134,153.714,126.225,153.189z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28067_",
    style: {
      fill: "#5f95fa"
    },
    d: "M141.035,138.938c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C141.944,140.313,141.944,139.463,141.035,138.938z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28066_",
    style: {
      fill: "#263238"
    },
    d: "M134.453,142.738c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C135.361,144.114,135.361,143.263,134.453,142.738z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28065_",
    style: {
      fill: "#5f95fa"
    },
    d: "M127.87,146.538c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C128.779,147.914,128.779,147.063,127.87,146.538z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28064_",
    style: {
      fill: "#263238"
    },
    d: "M121.288,150.339c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C122.197,151.714,122.197,150.863,121.288,150.339z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28063_",
    style: {
      fill: "#263238"
    },
    d: "M136.098,136.088c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.383,0.525,3.291,0C137.007,137.463,137.007,136.612,136.098,136.088z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28062_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.516,139.888c-0.909-0.525-2.383-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C130.425,141.263,130.425,140.413,129.516,139.888z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28061_",
    style: {
      fill: "#263238"
    },
    d: "M122.934,143.688c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C123.843,145.064,123.843,144.213,122.934,143.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28060_",
    style: {
      fill: "#5f95fa"
    },
    d: "M119.605,156.913c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C120.514,158.289,120.514,157.438,119.605,156.913z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28059_",
    style: {
      fill: "#263238"
    },
    d: "M114.669,154.063c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C115.578,155.438,115.578,154.588,114.669,154.063z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28058_",
    style: {
      fill: "#263238"
    },
    d: "M116.352,147.491c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C117.261,148.867,117.261,148.016,116.352,147.491z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28057_",
    style: {
      fill: "#5f95fa"
    },
    d: "M131.162,133.24c-0.909-0.525-2.382-0.525-3.291,0s-0.909,1.375,0,1.9 c0.909,0.525,2.382,0.525,3.291,0C132.071,134.616,132.071,133.765,131.162,133.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28056_",
    style: {
      fill: "#263238"
    },
    d: "M124.58,137.041c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C125.488,138.416,125.488,137.565,124.58,137.041z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28055_",
    style: {
      fill: "#5f95fa"
    },
    d: "M117.997,140.841c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C118.906,142.216,118.906,141.365,117.997,140.841z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28054_",
    style: {
      fill: "#263238"
    },
    d: "M111.415,144.641c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C112.324,146.016,112.324,145.166,111.415,144.641z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28053_",
    style: {
      fill: "#5f95fa"
    },
    d: "M109.732,151.216c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.375,0,1.9c0.909,0.525,2.382,0.525,3.291,0C110.641,152.591,110.641,151.74,109.732,151.216z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28052_",
    style: {
      fill: "#263238"
    },
    d: "M104.796,148.365c-0.909-0.525-2.382-0.525-3.291,0 c-0.909,0.525-0.909,1.376,0,1.9c0.909,0.525,2.382,0.525,3.291,0C105.705,149.741,105.705,148.89,104.796,148.365z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28050_",
    style: {
      fill: "#37474F"
    },
    d: "M116.704,164.554v5.056c0.53,0.011,1.07-0.087,1.48-0.324l36.688-21.185 c0.778-0.443,1.404-1.534,1.404-2.431v-1.826c0-0.789-0.486-1.729-1.145-2.247c0.508,0.443,0.422,1.048-0.259,1.437 l-36.688,21.185C117.773,164.456,117.233,164.564,116.704,164.554z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_28041_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28049_",
    style: {
      fill: "#263238"
    },
    d: "M124.129,125.092l-0.032-0.044c-0.355-0.48-1.061-0.627-1.578-0.328 l-31.927,18.434c-0.517,0.298-0.646,0.928-0.29,1.406l0.033,0.044c0.357,0.478,1.064,0.624,1.581,0.326l31.919-18.429 C124.352,126.202,124.484,125.572,124.129,125.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28048_",
    style: {
      fill: "#5f95fa"
    },
    d: "M124.129,125.092l-0.032-0.044c-0.355-0.48-1.061-0.627-1.578-0.328 l-23.736,13.704l1.325,1.777l23.729-13.699C124.352,126.202,124.484,125.572,124.129,125.092z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28047_",
    style: {
      fill: "#263238"
    },
    d: "M121.49,121.549l-0.033-0.044c-0.355-0.48-1.061-0.627-1.578-0.329 L87.953,139.61c-0.517,0.298-0.646,0.928-0.29,1.406l0.033,0.044c0.356,0.478,1.065,0.624,1.581,0.326l31.919-18.429 C121.713,122.66,121.844,122.029,121.49,121.549z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28046_",
    style: {
      fill: "#5f95fa"
    },
    d: "M121.49,121.549l-0.033-0.044c-0.355-0.48-1.061-0.627-1.578-0.329 l-7.936,4.58l1.325,1.777l7.928-4.575C121.713,122.66,121.844,122.029,121.49,121.549z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28045_",
    style: {
      fill: "#263238"
    },
    d: "M118.85,118.007l-0.032-0.044c-0.355-0.48-1.061-0.627-1.578-0.329 l-31.927,18.434c-0.517,0.298-0.647,0.928-0.29,1.406l0.033,0.045c0.357,0.478,1.064,0.624,1.581,0.326l31.919-18.429 C119.073,119.118,119.205,118.487,118.85,118.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28044_",
    style: {
      fill: "#5f95fa"
    },
    d: "M118.85,118.007l-0.032-0.044c-0.355-0.48-1.061-0.627-1.578-0.33 l-16.629,9.571l1.325,1.777l16.621-9.566C119.073,119.117,119.205,118.487,118.85,118.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28043_",
    style: {
      fill: "#263238"
    },
    d: "M116.211,114.465l-0.033-0.044c-0.355-0.48-1.061-0.627-1.578-0.329 l-31.927,18.434c-0.517,0.298-0.647,0.928-0.29,1.406l0.033,0.045c0.357,0.478,1.065,0.624,1.581,0.326l31.919-18.429 C116.434,115.575,116.565,114.945,116.211,114.465z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28042_",
    style: {
      fill: "#5f95fa"
    },
    d: "M116.211,114.465l-0.033-0.044c-0.355-0.48-1.061-0.627-1.578-0.329 l-28.981,16.732l1.325,1.777l28.973-16.727C116.434,115.575,116.565,114.945,116.211,114.465z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4576_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M122.024,403.807l-0.019-8.526c0-0.878,0.617-1.946,1.377-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,8.525c0,0.878-0.617,1.947-1.377,2.385l-10.165,5.87 C122.641,405.042,122.024,404.685,122.024,403.807z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4555_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4556_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4557_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4574_",
    style: {
      fill: "#5f95fa"
    },
    d: "M128.226,398.592l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.378,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 h0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.378-0.967,3.053-2.16,3.742 c-0.177,0.102-0.347,0.169-0.512,0.217L128.226,398.592z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4564_",
    style: {
      opacity: 0.2
    },
    d: "M128.226,398.592l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.378,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 h0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.378-0.967,3.053-2.16,3.742 c-0.177,0.102-0.347,0.169-0.512,0.217L128.226,398.592z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4558_",
    style: {
      fill: "#5f95fa"
    },
    d: "M127.546,397.169c0-1.378,0.967-3.053,2.16-3.741 c1.193-0.689,2.16-0.13,2.16,1.247c0,1.377-0.967,3.053-2.16,3.741C128.513,399.105,127.546,398.547,127.546,397.169z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4546_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4554_",
    style: {
      fill: "#455A64"
    },
    d: "M122.024,387.817l-0.019-42.903c0-0.878,0.617-1.946,1.377-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,42.902c0,0.879-0.617,1.947-1.377,2.386l-10.165,5.87 C122.641,389.051,122.024,388.695,122.024,387.817z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4553_",
    style: {
      fill: "#5f95fa"
    },
    d: "M125.9,384.186c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.578-1.256-1.292-0.844s-1.292,1.458-1.292,2.336l0.018,36.935C124.608,384.22,125.187,384.598,125.9,384.186z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4552_",
    style: {
      fill: "#263238"
    },
    d: "M131.068,381.202c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.578-1.256-1.292-0.844c-0.714,0.412-1.292,1.458-1.292,2.336l0.018,36.935 C129.776,381.236,130.355,381.614,131.068,381.202z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4547_",
    style: {
      fill: "#5f95fa"
    },
    d: "M129.776,380.357L129.758,354l2.584-1.492l0.018,26.357 c0,0.878-0.578,1.924-1.292,2.336C130.355,381.614,129.776,381.236,129.776,380.357z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4700_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.499,393.734l-0.019-8.526c0-0.878,0.617-1.946,1.377-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,8.525c0,0.879-0.617,1.947-1.377,2.386l-10.165,5.869 C140.115,394.969,139.498,394.613,139.499,393.734z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4694_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4695_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4696_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4699_",
    style: {
      fill: "#5f95fa"
    },
    d: "M145.7,388.519l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.377,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 l0,0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.377-0.967,3.052-2.16,3.742 c-0.177,0.102-0.347,0.168-0.512,0.217L145.7,388.519z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4698_",
    style: {
      opacity: 0.2
    },
    d: "M145.7,388.519l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.377,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 l0,0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.377-0.967,3.052-2.16,3.742 c-0.177,0.102-0.347,0.168-0.512,0.217L145.7,388.519z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4697_",
    style: {
      fill: "#5f95fa"
    },
    d: "M145.02,387.096c0-1.378,0.967-3.053,2.16-3.742 c1.193-0.689,2.16-0.13,2.16,1.247c0,1.378-0.967,3.053-2.16,3.741C145.988,389.032,145.02,388.474,145.02,387.096z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4631_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4693_",
    style: {
      fill: "#455A64"
    },
    d: "M139.499,377.744l-0.019-42.903c0-0.878,0.617-1.946,1.377-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,42.902c0,0.878-0.617,1.947-1.377,2.386l-10.165,5.869 C140.115,378.979,139.498,378.623,139.499,377.744z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M144.648,334.841c0-0.878-0.579-1.256-1.292-0.844c-0.713,0.412-1.292,1.458-1.292,2.336 l0.018,36.935c0,0.878,0.578,1.256,1.292,0.844c0.714-0.412,1.292-1.458,1.292-2.336L144.648,334.841z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M144.648,363.619l-2.584,1.492l0.018,8.158c0,0.878,0.578,1.256,1.292,0.844 c0.714-0.412,1.292-1.458,1.292-2.336L144.648,363.619z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4662_",
    style: {
      fill: "#263238"
    },
    d: "M148.542,371.129c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.579-1.256-1.292-0.844c-0.714,0.412-1.292,1.458-1.292,2.336l0.018,36.935 C147.251,371.163,147.829,371.541,148.542,371.129z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4638_",
    style: {
      fill: "#5f95fa"
    },
    d: "M147.251,370.285l-0.018-26.357l2.584-1.492l0.019,26.357 c0,0.878-0.579,1.924-1.292,2.336C147.829,371.541,147.251,371.163,147.251,370.285z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4712_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M156.973,383.644l-0.019-8.526c0-0.878,0.617-1.946,1.378-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,8.525c0,0.878-0.617,1.947-1.377,2.385l-10.165,5.87 C157.589,384.879,156.973,384.523,156.973,383.644z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4706_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4707_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4708_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4711_",
    style: {
      fill: "#5f95fa"
    },
    d: "M163.174,378.429l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.378,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 h0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.377-0.967,3.052-2.16,3.742 c-0.177,0.102-0.347,0.168-0.512,0.217L163.174,378.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4710_",
    style: {
      opacity: 0.2
    },
    d: "M163.174,378.429l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.378,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 h0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.377-0.967,3.052-2.16,3.742 c-0.177,0.102-0.347,0.168-0.512,0.217L163.174,378.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4709_",
    style: {
      fill: "#5f95fa"
    },
    d: "M162.495,377.006c0-1.378,0.967-3.053,2.16-3.741 c1.193-0.689,2.16-0.131,2.16,1.247c0,1.378-0.967,3.053-2.16,3.741C163.462,378.942,162.495,378.384,162.495,377.006z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4701_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4705_",
    style: {
      fill: "#455A64"
    },
    d: "M156.973,367.654l-0.019-42.903c0-0.878,0.617-1.946,1.378-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,42.902c0,0.879-0.617,1.947-1.377,2.386l-10.165,5.869 C157.589,368.889,156.973,368.533,156.973,367.654z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4704_",
    style: {
      fill: "#5f95fa"
    },
    d: "M160.849,364.023c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.578-1.256-1.292-0.844c-0.714,0.412-1.292,1.458-1.292,2.336l0.018,36.935 C159.557,364.057,160.135,364.435,160.849,364.023z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4703_",
    style: {
      fill: "#263238"
    },
    d: "M166.017,361.039c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.578-1.257-1.292-0.844c-0.714,0.412-1.292,1.458-1.292,2.336l0.018,36.935 C164.725,361.073,165.303,361.451,166.017,361.039z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4702_",
    style: {
      fill: "#5f95fa"
    },
    d: "M164.725,360.195l-0.018-26.357l2.584-1.492l0.018,26.357 c0,0.878-0.579,1.924-1.292,2.336C165.303,361.451,164.725,361.073,164.725,360.195z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4748_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M174.447,373.559l-0.019-8.526c0-0.878,0.617-1.946,1.377-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,8.525c0,0.879-0.616,1.947-1.377,2.386l-10.165,5.87 C175.063,374.793,174.447,374.437,174.447,373.559z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4735_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4737_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4738_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4747_",
    style: {
      fill: "#5f95fa"
    },
    d: "M180.648,368.343l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.377,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 l0,0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.377-0.967,3.052-2.16,3.742 c-0.177,0.102-0.347,0.169-0.512,0.217L180.648,368.343z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4740_",
    style: {
      opacity: 0.2
    },
    d: "M180.648,368.343l-1.139-0.658l-0.001-0.001l-0.008-0.005l0.001-0.001 c-0.386-0.228-0.625-0.708-0.625-1.392c0-1.377,0.967-3.053,2.16-3.741c0.596-0.344,1.135-0.376,1.525-0.152l0,0l0.002,0.001 l0,0l1.056,0.615l-0.181,0.325c0.059,0.194,0.101,0.407,0.101,0.657c0,1.377-0.967,3.052-2.16,3.742 c-0.177,0.102-0.347,0.169-0.512,0.217L180.648,368.343z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4739_",
    style: {
      fill: "#5f95fa"
    },
    d: "M179.969,366.921c0-1.378,0.967-3.053,2.16-3.741 c1.193-0.689,2.16-0.13,2.16,1.247c0,1.377-0.967,3.052-2.16,3.741C180.936,368.857,179.969,368.298,179.969,366.921z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4715_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4724_",
    style: {
      fill: "#455A64"
    },
    d: "M174.447,357.569l-0.019-42.903c0-0.878,0.617-1.946,1.377-2.385l10.166-5.869 c0.761-0.439,1.377-0.083,1.377,0.795l0.018,42.902c0,0.879-0.616,1.947-1.377,2.385l-10.165,5.87 C175.063,358.803,174.447,358.447,174.447,357.569z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4722_",
    style: {
      fill: "#5f95fa"
    },
    d: "M178.323,353.937c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.578-1.257-1.292-0.844c-0.714,0.412-1.292,1.458-1.292,2.336l0.018,36.935 C177.031,353.971,177.609,354.349,178.323,353.937z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4719_",
    style: {
      fill: "#263238"
    },
    d: "M183.491,350.953c0.714-0.412,1.292-1.458,1.292-2.336l-0.018-36.935 c0-0.878-0.578-1.256-1.292-0.844c-0.714,0.412-1.292,1.458-1.292,2.336l0.018,36.936 C182.199,350.987,182.777,351.366,183.491,350.953z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4717_",
    style: {
      fill: "#5f95fa"
    },
    d: "M182.199,350.109l-0.018-12.95l2.584-1.492l0.019,12.949 c0,0.878-0.579,1.924-1.292,2.336C182.777,351.366,182.199,350.987,182.199,350.109z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4751_",
    style: {
      fill: "#37474F"
    },
    d: "M172.973,382.317c-0.572,0.33-1.035,1.133-1.035,1.793 c0,0.66,0.464,0.928,1.035,0.598c0.572-0.33,1.035-1.133,1.035-1.793C174.008,382.255,173.544,381.987,172.973,382.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M164.349,387.306c-0.57,0.329-1.032,1.129-1.032,1.787c0,0.658,0.462,0.924,1.031,0.596 c0.57-0.329,1.031-1.129,1.031-1.787C165.38,387.243,164.919,386.977,164.349,387.306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M155.87,392.199c-0.568,0.328-1.028,1.125-1.028,1.78c0,0.655,0.46,0.921,1.028,0.593 c0.568-0.328,1.028-1.125,1.028-1.78C156.898,392.137,156.438,391.872,155.87,392.199z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4750_",
    style: {
      fill: "#37474F"
    },
    d: "M147.318,397.14c-0.566,0.327-1.024,1.121-1.024,1.774 c0,0.653,0.458,0.918,1.024,0.591c0.566-0.327,1.024-1.121,1.024-1.774C148.342,397.078,147.884,396.814,147.318,397.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_719_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_776_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_777_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M139.229,244.474c-0.213,0-0.426-0.055-0.617-0.165c-0.382-0.22-0.617-0.628-0.617-1.069 v-9.119c0-0.681,0.552-1.234,1.234-1.234c0.681,0,1.234,0.553,1.234,1.234v6.982l27.392-15.817v-8.405 c0-0.681,0.552-1.234,1.234-1.234s1.234,0.553,1.234,1.234v9.118c0,0.441-0.235,0.848-0.617,1.069l-29.86,17.242 C139.655,244.419,139.442,244.474,139.229,244.474z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_775_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M144.742,222.555c-0.148,0-0.298-0.026-0.444-0.083c-0.636-0.245-0.953-0.959-0.707-1.595 l8.952-23.221c0.165-0.426,0.551-0.727,1.005-0.782c0.454-0.055,0.899,0.147,1.16,0.521l8.951,12.885 c0.389,0.56,0.25,1.329-0.31,1.718c-0.558,0.389-1.327,0.251-1.717-0.309l-7.624-10.974l-8.114,21.049 C145.704,222.254,145.236,222.555,144.742,222.555z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_774_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M153.693,228.885c-0.681,0-1.234-0.552-1.234-1.234v-26.863c0-0.681,0.552-1.234,1.234-1.234 s1.234,0.552,1.234,1.234v26.863C154.927,228.333,154.374,228.885,153.693,228.885z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_778_",
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3897_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3898_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.229,244.474c-0.213,0-0.426-0.055-0.617-0.165c-0.382-0.22-0.617-0.628-0.617-1.069 v-9.119c0-0.681,0.552-1.234,1.234-1.234c0.681,0,1.234,0.553,1.234,1.234v6.982l27.392-15.817v-8.405 c0-0.681,0.552-1.234,1.234-1.234s1.234,0.553,1.234,1.234v9.118c0,0.441-0.235,0.848-0.617,1.069l-29.86,17.242 C139.655,244.419,139.442,244.474,139.229,244.474z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3896_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M144.742,222.555c-0.148,0-0.298-0.026-0.444-0.083c-0.636-0.245-0.953-0.959-0.707-1.595 l8.952-23.221c0.165-0.426,0.551-0.727,1.005-0.782c0.454-0.055,0.899,0.147,1.16,0.521l8.951,12.885 c0.389,0.56,0.25,1.329-0.31,1.718c-0.558,0.389-1.327,0.251-1.717-0.309l-7.624-10.974l-8.114,21.049 C145.704,222.254,145.236,222.555,144.742,222.555z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3874_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M153.693,228.885c-0.681,0-1.234-0.552-1.234-1.234v-26.863c0-0.681,0.552-1.234,1.234-1.234 s1.234,0.552,1.234,1.234v26.863C154.927,228.333,154.374,228.885,153.693,228.885z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Folders"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Folder_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M219.252,385.368c-0.259,0-0.517-0.068-0.752-0.204c-0.47-0.271-0.751-0.757-0.751-1.301v-72.899 c0-0.626,0.205-1.325,0.578-1.969c0.371-0.637,0.872-1.163,1.411-1.483l21.802-12.581c0.678-0.394,1.417-0.421,2.027-0.073 c0.485,0.278,0.822,0.718,0.985,1.261l1.762,5.875c0.119,0.392,0.359,0.677,0.675,0.802c0.315,0.124,0.681,0.081,1.033-0.122 l51.285-29.587c0.557-0.322,1.112-0.391,1.567-0.191l0.193,0.104c0.445,0.282,0.689,0.813,0.689,1.494v61.173 c0,1.291-0.876,2.809-1.993,3.454l-79.761,46.043C219.768,385.3,219.51,385.368,219.252,385.368z M242.64,295.512 c-0.213,0-0.432,0.065-0.651,0.193l-21.799,12.579c-0.401,0.237-0.799,0.662-1.09,1.161c-0.291,0.501-0.458,1.056-0.458,1.519 v72.899c0,0.22,0.114,0.417,0.305,0.527c0.188,0.108,0.416,0.109,0.608,0l79.761-46.043c0.839-0.485,1.547-1.713,1.547-2.681 v-61.173c0-0.351-0.096-0.617-0.264-0.732l-0.116-0.062c-0.146-0.065-0.431-0.01-0.728,0.161l-51.285,29.586 c-0.594,0.342-1.236,0.405-1.809,0.18c-0.576-0.227-1.003-0.716-1.202-1.376l-1.762-5.876c-0.098-0.323-0.288-0.58-0.537-0.724 C242.992,295.557,242.818,295.512,242.64,295.512z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Folder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2984_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3458_",
    style: {
      fill: "#5f95fa"
    },
    d: "M312.296,281.048c0-0.544-0.187-0.927-0.486-1.121l0.004-0.001l-0.02-0.011 c-0.012-0.008-0.025-0.015-0.038-0.022l-3.302-1.91c0,0-0.002-0.001-0.003-0.002l-0.006-0.003v0.001 c-0.32-0.181-0.76-0.154-1.246,0.126l-50.721,29.259l-1.369-4.56c-0.136-0.454-0.406-0.783-0.74-0.98l0.01-0.004l-3.334-1.925 l0.002,0.011c-0.463-0.274-1.054-0.286-1.623,0.042l-21.797,12.581c-0.979,0.565-1.772,1.939-1.772,3.069l0,72.687 c0,0.542,0.186,0.924,0.484,1.118l-0.005,0.004l0.034,0.02c0.005,0.003,0.009,0.006,0.015,0.008l3.3,1.903 c0.012,0.007,0.024,0.014,0.037,0.021l0.026,0.015v-0.005c0.317,0.159,0.739,0.129,1.206-0.141l79.572-45.941 c0.979-0.565,1.772-1.939,1.772-3.069L312.296,281.048z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3455_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M254.334,301.797c-0.458-0.254-1.031-0.246-1.588,0.074l-21.796,12.58 c-0.483,0.286-0.925,0.769-1.252,1.326l-3.323-1.923c0.319-0.557,0.761-1.048,1.252-1.326l21.795-12.58 c0.573-0.327,1.162-0.311,1.621-0.041v-0.008L254.334,301.797z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_783_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.684,279.854c-0.311-0.131-0.72-0.082-1.162,0.172l-51.285,29.587 c-0.982,0.565-2.038,0.147-2.365-0.941l-0.393-1.31l50.72-29.26c0.278-0.164,0.548-0.237,0.786-0.237 c0.172,0,0.328,0.041,0.458,0.115h0.008L311.684,279.854z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2985_",
    style: {
      opacity: 0.2
    },
    d: "M229.428,391.099c0.049,0.074,0.107,0.131,0.172,0.188l-3.217-1.85 c-0.008-0.008-0.008-0.008-0.016-0.008l-0.033-0.024c-0.123-0.082-0.221-0.196-0.303-0.344c-0.033-0.065-0.066-0.131-0.082-0.205 c-0.057-0.164-0.09-0.352-0.09-0.573l-0.008-72.687c0-0.074,0-0.139,0.008-0.213c0.016-0.147,0.041-0.294,0.074-0.442 c0.016-0.074,0.041-0.147,0.057-0.221c0.074-0.221,0.164-0.442,0.27-0.655c0.033-0.074,0.074-0.147,0.115-0.213l3.323,1.923 c-0.319,0.548-0.516,1.179-0.516,1.743v72.688c0,0.106,0.008,0.213,0.024,0.311c0.008,0.057,0.016,0.115,0.033,0.172 c0.008,0.033,0.017,0.057,0.025,0.09c0.016,0.041,0.033,0.082,0.049,0.115C229.338,390.969,229.379,391.034,229.428,391.099z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Folder_1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M283.07,379.17c-0.694,0-1.258-0.564-1.258-1.257v-1.675c0-0.253,0.205-0.458,0.458-0.458 c0.253,0,0.458,0.205,0.458,0.458v1.675c0,0.286,0.303,0.412,0.513,0.293l1.014-0.586c0.219-0.129,0.5-0.053,0.626,0.167 c0.127,0.219,0.052,0.5-0.167,0.626L283.698,379C283.502,379.111,283.287,379.17,283.07,379.17z M286.836,377.118 c-0.158,0-0.312-0.082-0.397-0.229c-0.127-0.219-0.052-0.499,0.167-0.626l3.917-2.262c0.218-0.128,0.5-0.052,0.626,0.167 c0.127,0.219,0.052,0.5-0.167,0.626l-3.917,2.262C286.992,377.099,286.914,377.118,286.836,377.118z M282.27,373.982 c-0.253,0-0.458-0.205-0.458-0.458V369c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523 C282.729,373.777,282.524,373.982,282.27,373.982z M293.103,373.5c-0.158,0-0.313-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.262c0.219-0.129,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626 l-3.917,2.262C293.259,373.481,293.181,373.5,293.103,373.5z M299.37,369.882c-0.159,0-0.313-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.261c0.219-0.129,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.168,0.626 l-3.917,2.261C299.527,369.863,299.448,369.882,299.37,369.882z M282.27,366.745c-0.253,0-0.458-0.205-0.458-0.458v-4.523 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523C282.729,366.54,282.524,366.745,282.27,366.745z  M305.637,366.264c-0.158,0-0.312-0.082-0.397-0.229c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.261 c0.22-0.128,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626l-3.917,2.261 C305.794,366.245,305.715,366.264,305.637,366.264z M311.905,362.647c-0.159,0-0.313-0.083-0.397-0.229 c-0.127-0.219-0.052-0.5,0.168-0.626l3.917-2.261c0.219-0.128,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626 l-3.917,2.261C312.061,362.627,311.983,362.647,311.905,362.647z M282.27,359.508c-0.253,0-0.458-0.205-0.458-0.458v-4.523 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523C282.729,359.303,282.524,359.508,282.27,359.508z  M318.173,359.029c-0.159,0-0.313-0.082-0.397-0.229c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.261 c0.22-0.129,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.168,0.626l-3.917,2.261 C318.33,359.009,318.251,359.029,318.173,359.029z M324.44,355.41c-0.158,0-0.312-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.261c0.219-0.128,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626 l-3.917,2.261C324.597,355.391,324.518,355.41,324.44,355.41z M282.27,352.271c-0.253,0-0.458-0.205-0.458-0.458v-4.522 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.522C282.729,352.066,282.524,352.271,282.27,352.271z  M330.707,351.793c-0.158,0-0.313-0.082-0.397-0.229c-0.127-0.219-0.052-0.5,0.168-0.626l3.917-2.262 c0.218-0.128,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626l-3.917,2.262 C330.864,351.774,330.785,351.793,330.707,351.793z M336.975,348.175c-0.158,0-0.313-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.262c0.219-0.127,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626 l-3.917,2.262C337.131,348.156,337.052,348.175,336.975,348.175z M282.27,345.035c-0.253,0-0.458-0.205-0.458-0.458v-4.523 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523C282.729,344.83,282.524,345.035,282.27,345.035z  M343.242,344.557c-0.158,0-0.312-0.082-0.397-0.229c-0.127-0.219-0.052-0.5,0.167-0.626l0.57-0.329 c0.591-0.342,1.11-1.241,1.11-1.923v-1.082c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v1.082 c0,1.015-0.688,2.208-1.568,2.716l-0.57,0.33C343.399,344.538,343.32,344.557,343.242,344.557z M345.152,338.113 c-0.253,0-0.458-0.205-0.458-0.458v-4.522c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.522 C345.61,337.908,345.405,338.113,345.152,338.113z M282.27,337.798c-0.253,0-0.458-0.205-0.458-0.458v-4.523 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523C282.729,337.594,282.524,337.798,282.27,337.798z  M345.152,330.877c-0.253,0-0.458-0.205-0.458-0.458v-4.523c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458 v4.523C345.61,330.672,345.405,330.877,345.152,330.877z M282.27,330.562c-0.253,0-0.458-0.205-0.458-0.458v-4.523 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523C282.729,330.357,282.524,330.562,282.27,330.562z  M345.152,323.64c-0.253,0-0.458-0.205-0.458-0.458v-4.523c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458 v4.523C345.61,323.435,345.405,323.64,345.152,323.64z M282.27,323.325c-0.253,0-0.458-0.205-0.458-0.458v-0.107 c0-0.495,0.161-1.045,0.454-1.549c0.289-0.499,0.684-0.913,1.11-1.166l1.418-0.818c0.219-0.128,0.5-0.051,0.626,0.167 c0.127,0.219,0.052,0.5-0.168,0.626l-1.414,0.816c-0.285,0.169-0.571,0.475-0.78,0.835c-0.21,0.361-0.33,0.758-0.33,1.089v0.107 C282.729,323.12,282.524,323.325,282.27,323.325z M287.374,318.725c-0.158,0-0.312-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.261c0.219-0.129,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626 l-3.917,2.261C287.53,318.706,287.452,318.725,287.374,318.725z M304.336,317.428c-0.663,0-1.236-0.406-1.498-1.062 c-0.094-0.236,0.02-0.501,0.255-0.595c0.234-0.096,0.501,0.021,0.595,0.255c0.185,0.46,0.651,0.607,1.088,0.357l2.088-1.205 c0.219-0.125,0.5-0.051,0.627,0.168c0.126,0.219,0.051,0.5-0.168,0.627l-2.088,1.204 C304.951,317.341,304.639,317.428,304.336,317.428z M345.152,316.403c-0.253,0-0.458-0.205-0.458-0.458v-4.522 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.522C345.61,316.198,345.405,316.403,345.152,316.403z  M293.642,315.108c-0.159,0-0.313-0.082-0.397-0.229c-0.127-0.219-0.052-0.5,0.167-0.626l3.917-2.261 c0.219-0.129,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626l-3.917,2.261 C293.798,315.089,293.72,315.108,293.642,315.108z M309.444,314.678c-0.159,0-0.313-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.168-0.626l3.917-2.26c0.219-0.129,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626 l-3.917,2.26C309.601,314.658,309.522,314.678,309.444,314.678z M302.479,314.056c-0.197,0-0.38-0.128-0.439-0.327l-0.592-1.972 c-0.064-0.215-0.19-0.385-0.352-0.479c-0.268-0.147-0.5-0.114-0.766,0.04l-0.192,0.112c-0.22,0.125-0.5,0.05-0.627-0.168 c-0.126-0.219-0.051-0.5,0.168-0.627l0.192-0.111c0.547-0.315,1.163-0.332,1.652-0.055c0.397,0.227,0.671,0.586,0.802,1.024 l0.591,1.972c0.074,0.243-0.064,0.498-0.307,0.57C302.566,314.05,302.523,314.056,302.479,314.056z M315.712,311.061 c-0.159,0-0.312-0.082-0.397-0.229c-0.126-0.219-0.051-0.5,0.168-0.627l3.918-2.26c0.219-0.126,0.5-0.051,0.627,0.168 c0.126,0.219,0.051,0.499-0.168,0.627l-3.918,2.26C315.869,311.042,315.79,311.061,315.712,311.061z M345.152,309.166 c-0.253,0-0.458-0.205-0.458-0.458v-4.522c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.522 C345.61,308.961,345.405,309.166,345.152,309.166z M321.981,307.445c-0.159,0-0.313-0.082-0.398-0.229 c-0.126-0.219-0.051-0.5,0.168-0.627l3.918-2.26c0.219-0.126,0.5-0.05,0.627,0.168c0.126,0.219,0.051,0.5-0.168,0.627l-3.918,2.26 C322.137,307.426,322.059,307.445,321.981,307.445z M328.25,303.829c-0.159,0-0.313-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.168-0.626l3.917-2.26c0.22-0.128,0.5-0.051,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626l-3.917,2.26 C328.406,303.809,328.328,303.829,328.25,303.829z M345.152,301.93c-0.253,0-0.458-0.205-0.458-0.458v-4.523 c0-0.253,0.205-0.458,0.458-0.458c0.253,0,0.458,0.205,0.458,0.458v4.523C345.61,301.725,345.405,301.93,345.152,301.93z  M334.518,300.214c-0.159,0-0.312-0.082-0.397-0.229c-0.127-0.219-0.052-0.5,0.167-0.626l3.918-2.261 c0.22-0.128,0.5-0.052,0.626,0.167c0.127,0.219,0.052,0.5-0.167,0.626l-3.918,2.261 C334.675,300.194,334.596,300.214,334.518,300.214z M340.786,296.598c-0.159,0-0.313-0.082-0.397-0.229 c-0.127-0.219-0.052-0.5,0.167-0.626l3.02-1.742c0.452-0.263,0.92-0.318,1.294-0.151l0.133,0.07 c0.021,0.011,0.063,0.039,0.081,0.052c0.202,0.152,0.243,0.44,0.092,0.642c-0.149,0.197-0.425,0.239-0.625,0.105l-0.084-0.046 c0.008,0.002-0.024-0.002-0.061-0.001c-0.103,0-0.234,0.044-0.371,0.123l-3.021,1.742 C340.943,296.578,340.864,296.598,340.786,296.598z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_9_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Botom_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1155_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1156_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1165_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M376.043,371.144c-0.157-4.035-1.751-41.723-1.751-41.723l18.828,11.418 c-3.033,23.257-4.309,30.362-4.525,34.234l0,0c0.027,0.091,0.094,0.423,0.068,0.996c-0.19,4.601-5.487,6.892-9.661,9.811 c-1.649,1.153-6.446,4.56-11.246,6.75c-3.005,1.371-8.998,1.286-9.669-0.634c5.081-3.583,10.953-7.487,15.043-11.642 C375.083,378.37,376.232,375.986,376.043,371.144z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M352.169,396.698c-0.236-0.009-0.695,2.764,0.547,3.996c1.434,1.423,5.707,3.831,11.491,3.252 c5.783-0.579,8.968-2.363,11.346-4.335c2.377-1.972,5.71-4.754,8.336-5.27c2.438-0.479,5.107-1.55,5.91-2.32 c0.803-0.769,0.824-4.323,0.824-4.323L352.169,396.698z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1163_",
    style: {
      fill: "#455A64"
    },
    d: "M388.671,373.949c0,0,0.629-0.007,0.748,0.82 c0.141,0.985,0.308,3.851,0.63,5.471c0.447,2.251,0.803,6.869,0.42,8.676c-0.383,1.806-4.371,2.922-6.927,3.852 c-2.611,0.95-5.665,2.995-8.361,5.198c-2.79,2.28-8.566,4.456-12.318,4.373c-5.729-0.125-9.376-1.924-10.441-4.165 c-1.317-2.772-0.813-4.688,5.884-7.698c1.268-0.569,5.703-3.093,7.47-4.319c4.004-2.778,6.635-5.756,8.665-10.486 c0.237-0.553,0.487-1.166,0.999-1.433c0.392-0.204,0.855-0.156,1.284-0.075c1.09,0.205,4.246,0.746,5.227,1.292 c0.867,0.483,2.1,1.053,2.037,2.26c-0.022,0.42-0.151,0.826-0.293,1.219c-0.088,0.243-0.162,0.569,0.035,0.723 c0.186,0.145,0.445-0.003,0.622-0.16c0.713-0.633,1.249-1.459,1.856-2.207c0.326-0.401,0.679-0.783,1.083-1.094 c0.367-0.283,0.827-0.413,1.155-0.737C388.447,375.46,388.632,374.515,388.671,373.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M358.118,390.473c8.267,0.921,11.729,6.636,10.68,10.767c-2.082,0.7-4.219,1.137-5.934,1.1 c-5.729-0.125-9.612-1.93-10.677-4.171C350.944,395.553,352.155,392.635,358.118,390.473z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M369.376,391.732c0.09,0.004,0.182-0.025,0.26-0.088c0.179-0.145,0.213-0.416,0.079-0.606 c-1.099-1.553-4.354-3.675-7.38-3.438c-0.224,0.017-0.393,0.225-0.376,0.463c0.015,0.238,0.203,0.417,0.432,0.4 c2.824-0.213,5.807,1.868,6.678,3.099C369.143,391.669,369.258,391.728,369.376,391.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M372.719,389.613c0.09,0.003,0.182-0.025,0.26-0.088c0.179-0.144,0.214-0.416,0.079-0.606 c-1.1-1.554-4.357-3.682-7.38-3.438c-0.224,0.017-0.392,0.225-0.376,0.463c0.015,0.237,0.199,0.416,0.432,0.4 c2.824-0.217,5.807,1.868,6.678,3.099C372.487,389.55,372.601,389.609,372.719,389.613z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M376.021,386.901c0.09,0.003,0.182-0.025,0.26-0.088c0.179-0.144,0.214-0.416,0.079-0.606 c-1.099-1.554-4.368-3.678-7.38-3.438c-0.224,0.017-0.392,0.225-0.376,0.463c0.015,0.238,0.201,0.415,0.432,0.4 c2.82-0.214,5.806,1.868,6.678,3.099C375.789,386.838,375.904,386.897,376.021,386.901z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M379.284,384.177c0.088,0.003,0.178-0.024,0.255-0.085c0.181-0.142,0.22-0.413,0.088-0.605 c-1.509-2.201-5.046-3.746-8.068-3.508c-0.224,0.017-0.393,0.225-0.376,0.463c0.015,0.238,0.202,0.41,0.432,0.4 c2.721-0.213,6.019,1.207,7.359,3.158C379.048,384.112,379.165,384.172,379.284,384.177z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1159_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1162_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M409.422,338.919l20.489-3.597c0.267,12.753-0.6,29.762-1.002,41.519 c-0.077,2.252,0.848,17.486,0.14,22.147c-1.064,7.002-10.019,6.351-10.679,2.203c-0.661-4.148-0.964-21.823-1.075-23.656 c-0.267-7.67-4.178-20.636-6.832-34.334C410.332,342.525,409.546,339.575,409.422,338.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M415.141,404.195c-0.002,4.095,0.512,6.84,1.923,9.328c1.412,2.487,4.313,3.416,7.344,2.897 c3.031-0.52,6.975-2.161,8.054-5.628c1.079-3.467,1.058-5.889,0.62-9.713L415.141,404.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1158_",
    style: {
      fill: "#455A64"
    },
    d: "M428.954,375.542c1.225,0.164,1.182,5.497,1.544,11.024 c0.388,5.924,2.13,8.47,2.504,13.33c0.428,5.553-0.04,7.994-2.335,11.197c-2.294,3.204-9.878,6.023-13.211,1.034 c-2.717-4.066-2.567-8.384-1.949-13.866c0.639-5.667,1.138-9.65,1.16-13.978c0.021-4.138-0.583-8.004,0.516-8.397 c0.044,0.61,0.075,1.383,0.125,1.983c0.038,0.46,0.02,2.7,0.708,2.763c0.097-0.522,0.116-1.014,0.112-1.552 c-0.004-0.468,0.071-0.974,0.421-1.31c0.353-0.338,1.447-0.569,1.951-0.63c1.225-0.149,2.456-0.274,3.693-0.302 c0.616-0.014,1.233-0.004,1.848,0.039c0.498,0.036,1.084,0.11,1.546,0.3c0.284,0.117,0.54,0.325,0.631,0.6 c0.067,0.203,0.038,0.421,0.024,0.633c-0.024,0.381,0.004,0.765,0.083,1.139c0.035,0.165,0.143,0.371,0.322,0.342 c0.145-0.023,0.212-0.185,0.221-0.321c0.047-0.664-0.014-1.153,0.002-1.928c0.007-0.358,0.03-0.697,0.047-1.056 C428.934,376.235,428.957,375.896,428.954,375.542z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M433.142,403.108c-0.004,3.432-0.363,5.761-2.159,8.268 c-2.294,3.204-10.473,5.997-13.806,1.01c-1.659-2.482-1.966-5.316-2.034-8.193 C417.555,400.65,429.903,399.772,433.142,403.108z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M418.679,398.397c0.052-0.002,0.103-0.011,0.154-0.03c0.051-0.019,5.211-1.895,10.678-0.372 c0.242,0.064,0.495-0.06,0.568-0.284c0.071-0.224-0.068-0.46-0.311-0.528c-5.783-1.608-11.058,0.315-11.281,0.396 c-0.234,0.088-0.346,0.334-0.251,0.551C418.311,398.302,418.492,398.403,418.679,398.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M429.473,393.874c0.173-0.006,0.335-0.103,0.405-0.261c0.094-0.217-0.018-0.465-0.252-0.554 c-5.407-2.064-11.023,0.203-11.26,0.301c-0.231,0.094-0.333,0.344-0.228,0.558c0.105,0.213,0.379,0.305,0.604,0.215 c0.053-0.021,5.508-2.218,10.539-0.291C429.343,393.866,429.408,393.876,429.473,393.874z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M429.401,389.985c0.17-0.006,0.33-0.1,0.401-0.254c0.099-0.216-0.008-0.465-0.24-0.557 c-5.941-2.38-11.26,0.147-11.483,0.255c-0.223,0.108-0.308,0.364-0.19,0.571c0.118,0.208,0.401,0.289,0.618,0.18 c0.049-0.025,5.167-2.443,10.696-0.23C429.268,389.976,429.336,389.987,429.401,389.985z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M429.302,385.615c0.168-0.005,0.326-0.097,0.399-0.249c0.102-0.213-0.001-0.464-0.232-0.56 c-5.561-2.316-11.33,0.255-11.572,0.368c-0.226,0.102-0.317,0.356-0.204,0.566c0.111,0.21,0.385,0.3,0.613,0.193 c0.057-0.025,5.629-2.507,10.792-0.356C429.165,385.605,429.234,385.617,429.302,385.615z"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1157_",
    style: {
      fill: "#455A64"
    },
    d: "M422.728,239.932c0.012,23.191,3.052,69.628,3.052,69.628 c0.278,2.854,3.876,15.465,4.131,25.762c0.409,16.532-0.222,27.996-0.222,27.996s-8.667,3.389-14.933,0.779 c0,0-8.007-33.258-10.1-44.027c-2.493-12.825-5.657-26.72-5.657-26.72l-4.23,26.9c0,0,0.736,7.653-0.573,17.621 c-0.892,6.79-3.564,25.499-3.564,25.499s-9.01,3.302-15.716-0.765c0,0-1.838-43.328-1.925-49.6 c-0.116-8.39,0.347-31.51,0.755-71.745L422.728,239.932z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#37474F"
    },
    d: "M398.999,293.35l-6.24-33.213c0,0-6.666-0.1-11.707-5.262c0,0,0.542,5.059,9.864,8.302 l5.954,29.479l-2.101,27.594L398.999,293.35z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M374.745,178.7c-6.661,3.74-22.158,13.085-26.792,16.057c0,0-14.442-8.699-19.764-12.388 c-2.343-1.624-2.821-2.536-3.083-3.642c-0.429-1.806-0.617-2.84-1.277-4.287c-0.719-1.575-1.128-2.107-1.971-4.086 c-0.842-1.979-1.632-5.991-1.327-7.794c-0.503-0.827-2.572-0.792-3.388,1.385c-0.816,2.177-0.412,4.553-0.314,5.658 c0.11,1.23,0.348,2.533-0.018,2.747c-0.366,0.215-2.152-0.618-3.929-0.972c-1.777-0.353-3.362-1.055-5.293-0.4 c-1.931,0.654-1.762,2.473-1.485,3.114c0.29,0.672,1.085,1.143,1.085,1.143s-1.037-0.127-1.858,0.647 c-0.82,0.774-0.729,2.723,0.079,3.418c0,0-1.249,0.019-1.447,1.401c-0.167,1.162,0,2.303,1.173,2.716 c0,0-0.947,0.258-0.987,0.818c-0.04,0.56,0.003,1.897,0.987,2.511c0.984,0.615,3.336,0.663,3.336,0.663s0.188,0.41,1.311,0.939 c0.392,0.185,1.331,0.64,2.872,1.25c1.721,0.682,2.774,0.938,4.162,1.139c1.388,0.201,2.201-0.031,6.068,3.449 c2.487,2.238,12.566,10.515,17.516,13.861c8.261,5.585,9.23,5.323,17.707,1.17c8.362-4.096,20.785-10.34,20.785-10.34 l6.454-22.427C385.345,176.451,379.766,175.881,374.745,178.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M311.137,172.346c0.245,0.165,0.479,0.351,0.688,0.565c0.208,0.217,0.401,0.443,0.536,0.738 l-0.067-0.06c1.255,0.247,2.554,0.748,3.42,1.798c0.212,0.26,0.397,0.55,0.518,0.881c0.115,0.328,0.156,0.724-0.004,1.086 c-0.076,0.159-0.165,0.335-0.357,0.47c-0.201,0.131-0.424,0.13-0.593,0.121c-0.347-0.033-0.646-0.099-0.96-0.136 c-0.616-0.08-1.258-0.078-1.907-0.147c-0.653-0.06-1.297-0.242-1.894-0.495c-1.181-0.531-2.319-1.132-3.327-1.932 c0.531,0.354,1.116,0.616,1.692,0.888c0.58,0.268,1.153,0.545,1.746,0.755c0.595,0.208,1.199,0.351,1.82,0.406 c0.623,0.056,1.264,0.043,1.918,0.114c0.322,0.032,0.651,0.095,0.941,0.117c0.303,0.034,0.405-0.049,0.544-0.331 c0.221-0.473-0.063-1.097-0.431-1.557c-0.761-0.963-1.95-1.535-3.16-1.861l-0.052-0.014l-0.016-0.046 c-0.088-0.253-0.258-0.506-0.439-0.729C311.566,172.752,311.36,172.54,311.137,172.346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M314.059,177.574c0.559-0.018,1.112,0.401,1.264,0.978c0.176,0.588-0.153,1.224-0.607,1.576 c-0.834,0.747-1.864,1.302-3.051,1.43c-0.602,0.014-1.154-0.171-1.678-0.348c-0.523-0.191-1.037-0.384-1.544-0.597 c-1.018-0.418-2.034-0.841-3.032-1.312c1.063,0.298,2.108,0.644,3.151,0.994c1.039,0.329,2.075,0.836,3.093,0.836 c0.489-0.002,1.016-0.213,1.503-0.407c0.482-0.213,0.921-0.522,1.365-0.841c0.424-0.29,0.705-0.776,0.61-1.289 C315.06,178.086,314.61,177.648,314.059,177.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M312.302,181.242c0.493-0.035,1.037,0.073,1.432,0.458c0.193,0.193,0.302,0.494,0.263,0.779 c-0.048,0.271-0.094,0.508-0.237,0.769c-0.322,0.507-0.826,0.693-1.257,0.941c-0.449,0.221-0.925,0.471-1.504,0.476 c-0.576-0.014-1.041-0.289-1.486-0.418c-0.459-0.142-0.947-0.212-1.434-0.31c-0.977-0.174-1.962-0.329-2.942-0.523 c1,0.017,1.995,0.089,2.989,0.195c0.498,0.047,0.997,0.126,1.496,0.259c0.507,0.142,0.946,0.37,1.383,0.364 c0.429,0.014,0.885-0.189,1.324-0.395c0.431-0.218,0.905-0.433,1.153-0.766c0.116-0.166,0.194-0.422,0.248-0.635 c0.045-0.207-0.014-0.427-0.154-0.603C313.296,181.469,312.79,181.298,312.302,181.242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M311.44,184.399c0.174,0.118,0.278,0.338,0.299,0.564c0.012,0.229-0.056,0.452-0.153,0.652 c-0.221,0.396-0.494,0.674-0.783,0.99c-0.156,0.142-0.321,0.275-0.495,0.396c-0.172,0.127-0.41,0.233-0.605,0.268 c-0.409,0.098-0.815,0.149-1.231,0.14l1.124-0.455c0.188-0.093,0.332-0.141,0.478-0.27c0.151-0.12,0.293-0.252,0.43-0.391 c0.283-0.255,0.573-0.571,0.799-0.85C311.52,185.157,311.648,184.771,311.44,184.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M316.035,177.277c-0.633,1.057-1.07,4.372,0.427,6.5c1.498,2.129,2.975,2.666,2.975,2.666 s-1.91-0.516-3.365-2.041c-1.455-1.525-1.744-2.713-1.744-2.713l-0.458,0.721c-0.109-0.496-0.108-0.893-1.266-1.162 c0,0,1.306-0.588,1.863-1.125c0.557-0.537,1.387-1.394,0.209-2.477c0,0,0.473,0.101,0.914,0.067 C316.032,177.681,316.035,177.277,316.035,177.277z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M388.431,174.418c-8.059-0.375-11.171,0.904-17.709,5.042c-7.048,4.46-15.88,10.694-15.88,10.694 s5.737,4.512,7.995,17.035l16.855-7.892L388.431,174.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M347.953,194.757c4.366,3.074,5.577,6.867,5.577,6.867s0.387-5.287-3.963-7.89L347.953,194.757z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1088_",
    style: {
      fill: "#5f95fa"
    },
    d: "M373.857,194.873c1.976-14.677,8.076-19.037,10.927-19.753 s7.827-1.626,17.491-0.652c9.664,0.975,16.348,3.506,16.348,3.506c5.023,1.402,4.945,11.76,4.69,20.493 c-0.219,7.505-0.397,18.484-0.52,27.839c-0.078,5.97,0.247,12.169,0.332,16.809c-10.552,6.965-38.135,10.096-49.538,3.507 c0,0-0.382-8.591-0.495-15.868C372.852,215.434,373.229,199.538,373.857,194.873z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_965_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1116_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M380.186,147.078c-1.306-0.983-2.437-2.096-3.053-3.89c-0.663-1.929-0.897-3.464-0.737-5.509 c0.036-0.458,0.282-1.505,0.516-1.894c0.43-0.714,1.319-0.913,2.115-1.027c0.509-0.073,1.018-0.137,1.529-0.192 c-0.91-0.977-1.844-1.993-2.304-3.272c-0.34-0.946-0.396-2.004-0.158-2.984c0.065-0.266,0.156-0.535,0.338-0.73 c0.424-0.454,1.139-0.374,1.724-0.211c4.721,1.315,9.297,0.978,10.903,0.897c2.896-0.147,4.347-0.491,8.325-0.842 c3.978-0.352,11.067,1.496,12.26,9.002c5.32,0.903,5.968,9.503,4.427,13.122c-2.837,6.664-5.538,11.068-6.977,15.872 c-0.275-0.197-18.083-10.608-22.162-13.529c-1.529-1.095-3.057-2.189-4.586-3.284 C381.611,148.078,380.874,147.596,380.186,147.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M414.298,160.504c-3.18,2.362-5.237,0.083-5.237,0.083l0.043,16.2 c-6.588,8.536-24.168,7.144-16.551-1.477l-0.157-3.879c0,0-2.659,0.151-4.862-0.217c-0.963-0.161-2.059-0.57-2.825-1.056 c-1.808-1.132-3.09-2.652-3.866-5.201c-0.918-3.039-1.463-7.102-1.48-11.608c-0.018-4.706,0.462-10.785,2.017-13.94 c2.816-2.482,11.199-2.722,18.249-0.702c0.127,1.762-0.053,3.3,1.354,5.234c0.69,0.949,1.78,1.672,2.694,2.119 c0.187,3.422,0.325,4.345,0.959,5.854c0.352,0.869,1.05,2.172,2.79,1.542c0.821-0.298,1.43-2.115,2.279-3.323 c1.142-1.624,4.73-2.386,6.468,1.133C417.929,154.85,416.468,158.875,414.298,160.504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M392.399,171.427c3.56-0.355,9.903-1.7,11.738-3.874c1.836-2.174,3.26-7.191,3.26-7.191 s-0.708,5.636-2.098,8.085c-1.39,2.449-4.469,3.436-6.714,4.12c-2.244,0.684-6.103,1.016-6.103,1.016L392.399,171.427z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1089_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1107_",
    style: {
      fill: "#263238"
    },
    d: "M394.801,146.652l3.405,1.48c0.389-0.975-0.058-2.097-0.998-2.505 C396.268,145.218,395.19,145.677,394.801,146.652z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1106_",
    style: {
      fill: "#263238"
    },
    d: "M384.936,146.461l-3.283,1.734c-0.462-0.942-0.102-2.095,0.805-2.574 C383.365,145.143,384.474,145.518,384.936,146.461z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1104_",
    style: {
      fill: "#B16668"
    },
    d: "M395.906,159.665l-6.174,2.365c0.72,1.725,2.688,2.594,4.392,1.941 C395.829,163.316,396.627,161.389,395.906,159.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M395.716,160.955c-1.768,0.001-3.2,1.423-3.225,3.185c0.54,0.074,1.099,0.035,1.633-0.17 c1.27-0.486,2.034-1.68,2.045-2.969C396.02,160.979,395.871,160.955,395.716,160.955z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1090_",
    style: {
      fill: "#F28F8F"
    },
    points: "390.849,147.785 389.732,158.914 383.971,156.493  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M396.886,150.768c0.013,0.839-0.656,1.53-1.495,1.543c-0.839,0.013-1.53-0.656-1.543-1.495 c-0.013-0.839,0.656-1.53,1.495-1.543C396.182,149.259,396.873,149.929,396.886,150.768z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M385.459,150.768c0.013,0.839-0.656,1.53-1.495,1.543c-0.839,0.013-1.53-0.656-1.543-1.495 c-0.013-0.839,0.656-1.53,1.495-1.543C384.755,149.259,385.446,149.929,385.459,150.768z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M419.62,178.262c7.217,1.252,11.049,3.228,12.894,8.903c2.624,8.068,8.046,28.363,10.074,37.64 c1.09,4.985,2.194,8.354-1.793,11.943c-4.28,3.854-13.933,11.554-22.375,17.176c-1.665,1.109-6.034,5.17-7.62,6.002 c-9.631,5.047-20.756,3.733-20.756,3.733l10.553-6.387l1.885-3.573l22.608-23.811l-8.323-31.964 C416.768,197.923,414.12,181.732,419.62,178.262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28F8F"
    },
    d: "M425.091,229.888c3.027-3.043,7.423-3.044,7.423-3.044s-3.056-1.601-7.97,0.944L425.091,229.888 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455A64"
    },
    d: "M418.623,177.974c3.3,0.613,6.922,0.972,10.311,3.109c3.389,2.137,3.979,4.716,6.558,12.673 c2.579,7.958,5.155,21.16,5.155,21.16s-8.03,4.599-18.921,4.742c0,0-3.489-13.117-5.119-18.326 C415.539,197.924,412.577,186.757,418.623,177.974z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_784_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_894_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_909_",
    style: {
      fill: "#5f95fa"
    },
    d: "M410.232,248.796l0.022,0.99c0.022,0.999-0.491,1.936-1.342,2.454 l-26.329,15.934c-0.426,0.259-0.908,0.392-1.392,0.403c-0.48,0.011-0.967-0.101-1.404-0.341l-49.541-27.163 c-0.878-0.48-1.432-1.394-1.454-2.393l-0.015-0.68l52.373,28.717L410.232,248.796z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_892_",
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_893_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M410.232,248.796l0.022,0.99c0.022,0.999-0.491,1.936-1.342,2.454 l-26.329,15.934c-0.426,0.259-0.908,0.392-1.392,0.403c-0.48,0.011-0.967-0.101-1.404-0.341l-49.541-27.163 c-0.878-0.48-1.432-1.394-1.454-2.393l-0.015-0.68l52.373,28.717L410.232,248.796z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_886_",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_887_",
    d: "M410.232,248.796l0.022,0.99c0.022,0.999-0.491,1.936-1.342,2.454l-26.329,15.934 c-0.426,0.259-0.908,0.392-1.392,0.403c-0.48,0.011-0.967-0.101-1.404-0.341l-49.541-27.163 c-0.878-0.48-1.432-1.394-1.454-2.393l-0.015-0.68l52.373,28.717L410.232,248.796z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_885_",
    style: {
      fill: "#5f95fa"
    },
    d: "M328.778,237.999l28.636-17.384c0.509-0.309,1.145-0.323,1.667-0.037 l50.96,27.946c0.25,0.137,0.258,0.494,0.014,0.642l-28.905,17.551L328.778,237.999z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_872_",
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_878_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M328.778,237.999l28.636-17.384c0.509-0.309,1.145-0.323,1.667-0.037 l50.96,27.946c0.25,0.137,0.258,0.494,0.014,0.642l-28.905,17.551L328.778,237.999z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_871_",
    style: {
      fill: "#5f95fa"
    },
    points: "380.908,263.992 396.353,254.624 350.482,229.479 334.954,238.801  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_867_",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_868_",
    style: {
      fill: "#FFFFFF"
    },
    points: "380.908,263.992 396.353,254.624 350.482,229.479 334.954,238.801  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_866_",
    style: {
      fill: "#5f95fa"
    },
    points: "388.499,238.98 388.215,239.152 380.644,243.747 366.835,236.175  366.547,236.02 374.402,231.251  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_854_",
    style: {
      fill: "#5f95fa"
    },
    points: "388.215,239.152 380.644,243.747 366.835,236.175 374.409,231.58  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_843_",
    style: {
      fill: "#FFFFFF"
    },
    points: "388.215,239.152 380.644,243.747 366.835,236.175 374.409,231.58  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_841_",
    style: {
      fill: "#5f95fa"
    },
    d: "M381.151,266.716l0.041,1.861c-0.48,0.011-0.967-0.101-1.404-0.341 l-49.541-27.163c-0.878-0.48-1.432-1.394-1.454-2.393l-0.015-0.68L381.151,266.716z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_",
    style: {
      opacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_836_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.151,266.716l0.041,1.861c-0.48,0.011-0.967-0.101-1.404-0.341 l-49.541-27.163c-0.878-0.48-1.432-1.394-1.454-2.393l-0.015-0.68L381.151,266.716z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_829_",
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_833_",
    d: "M381.151,266.716l0.041,1.861c-0.48,0.011-0.967-0.101-1.404-0.341l-49.541-27.163 c-0.878-0.48-1.432-1.394-1.454-2.393l-0.015-0.68L381.151,266.716z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_827_",
    style: {
      fill: "#5f95fa"
    },
    d: "M380.371,267.146c-0.918,0.378-1.972,0.333-2.859-0.157l-49.323-27.046 c-0.868-0.476-1.474-1.31-1.662-2.281l-6.033-31.678c-0.033-0.181-0.052-0.362-0.056-0.543 c-0.02-0.886,0.314-1.741,0.927-2.376l51.257,28.11c0.64,0.354,1.09,0.971,1.228,1.687L380.371,267.146z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_797_",
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_798_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M380.371,267.146c-0.918,0.378-1.972,0.333-2.859-0.157l-49.323-27.046 c-0.868-0.476-1.474-1.31-1.662-2.281l-6.033-31.678c-0.033-0.181-0.052-0.362-0.056-0.543 c-0.02-0.886,0.314-1.741,0.927-2.376l51.257,28.11c0.64,0.354,1.09,0.971,1.228,1.687L380.371,267.146z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_794_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_796_",
    style: {
      fill: "#5f95fa"
    },
    d: "M381.151,266.718l-0.329,0.198c-0.145,0.086-0.295,0.163-0.451,0.23 l-6.521-34.284c-0.138-0.717-0.588-1.334-1.228-1.687l-51.257-28.11c0.191-0.2,0.418-0.377,0.664-0.529l51.361,28.162 c0.64,0.353,1.089,0.97,1.228,1.687L381.151,266.718z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_791_",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_793_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M381.151,266.718l-0.329,0.198c-0.145,0.086-0.295,0.163-0.451,0.23 l-6.521-34.284c-0.138-0.717-0.588-1.334-1.228-1.687l-51.257-28.11c0.191-0.2,0.418-0.377,0.664-0.529l51.361,28.162 c0.64,0.353,1.089,0.97,1.228,1.687L381.151,266.718z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5f95fa"
    },
    d: "M373.368,231.82l0.774-0.472c0.234,0.302,0.403,0.652,0.477,1.036l6.532,34.333l-0.329,0.198 c-0.145,0.087-0.295,0.163-0.451,0.23l-6.521-34.284C373.776,232.476,373.604,232.123,373.368,231.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M373.368,231.82l0.774-0.472c0.234,0.302,0.403,0.652,0.477,1.036l6.532,34.333 l-0.329,0.198c-0.145,0.087-0.295,0.163-0.451,0.23l-6.521-34.284C373.776,232.476,373.604,232.123,373.368,231.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M373.368,231.82l0.774-0.472c0.234,0.302,0.403,0.652,0.477,1.036l6.532,34.333l-0.329,0.198 c-0.145,0.087-0.295,0.163-0.451,0.23l-6.521-34.284C373.776,232.476,373.604,232.123,373.368,231.82z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_787_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_790_",
    style: {
      fill: "#455A64"
    },
    d: "M352.294,238.398c-0.404-2.121-2.664-4.9-5.048-6.207 c-2.384-1.307-3.989-0.648-3.586,1.474c0.404,2.121,2.664,4.9,5.049,6.207C351.093,241.179,352.698,240.52,352.294,238.398z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA8A7"
    },
    d: "M411.191,245.983c-2.759,1.936-6.473,0.377-10.134,0.822c-3.661,0.444-6.795,1.34-9.733,1.255 s-4.384,0.512-2.329,2.866c2.055,2.354,7.96,0.998,9.551,1.714c1.59,0.717,2.585,3.281,0.743,5.424 c-1.723,2.005,9.828-1.871,11.369-4.248C412.198,251.439,413.283,246.286,411.191,245.983z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_5_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_6_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1179_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1223_",
    style: {
      fill: "#5f95fa"
    },
    d: "M392.656,112.904l2.835-5.33l-2.281-6.583v-4.03l6.979,4.03v4.03l-3,5.197 c-0.051,0.088-0.124,0.145-0.204,0.181l0.002,0.003L392.656,112.904z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1222_",
    style: {
      opacity: 0.3
    },
    d: "M392.656,112.904l2.835-5.33l-2.281-6.583v-4.03l6.979,4.03v4.03l-3,5.197 c-0.051,0.088-0.124,0.145-0.204,0.181l0.002,0.003L392.656,112.904z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1221_",
    style: {
      fill: "#5f95fa"
    },
    d: "M379.62,68.564c0-1.334,0.936-2.957,2.092-3.625l1.704-0.984 c1.155-0.667,3.029-0.667,4.185,0l24.459,14.08c1.156,0.667,2.093,2.29,2.093,3.624v27.241c0,1.335-0.937,2.957-2.093,3.625 l-1.704,0.984c-1.156,0.667-3.03,0.667-4.185,0l-10.365-5.95l-2.994,5.187c-0.191,0.332-0.684,0.285-0.809-0.077l-3.165-9.136 l-7.126-4.103c-1.156-0.667-2.092-2.29-2.092-3.624L379.62,68.564z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1219_",
    style: {
      opacity: 0.3
    },
    d: "M414.153,108.902c0,1.334-0.937,2.957-2.093,3.624l-1.704,0.984 c-1.044,0.603-2.67,0.656-3.828,0.169c0.985,0.372,1.735-0.183,1.735-1.377l0-27.241c0-0.667-0.234-1.407-0.613-2.063l5.889-3.4 c0.379,0.656,0.613,1.395,0.613,2.063V108.902z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1218_",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M379.688,67.97c0.244-0.888,1.054-1.171,2.021-0.615l24.463,14.083 c0.576,0.332,1.103,0.898,1.474,1.562l5.887-3.397c-0.381-0.664-0.898-1.23-1.474-1.562l-24.454-14.083 c-1.162-0.664-3.036-0.664-4.188,0l-1.708,0.986C380.723,65.51,379.893,66.779,379.688,67.97z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2990_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1215_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M383.785,87.699l1.435-0.682c-2.108-6.879,0.031-9.147,3.748-9.462 c-1.463,0.9-2.208,4.628-0.996,8.156l1.435-0.682c0.281-0.134,0.743,0.366,0.75,0.811l0.113,6.639 c0.005,0.304-0.218,0.41-0.481,0.228l-5.734-3.969C383.67,88.473,383.504,87.833,383.785,87.699z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1213_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M388.164,82.076c0.005-2.141,0.652-3.919,1.603-4.503 c0,0,3.915,0.338,7.678,5.858C397.444,83.43,392.088,79.009,388.164,82.076z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1168_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2993_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M404.099,92.721l-1.435,0.682c2.108,6.879-0.032,9.147-3.748,9.462 c1.463-0.9,2.208-4.628,0.997-8.156l-1.435,0.682c-0.281,0.134-0.743-0.366-0.75-0.811l-0.113-6.639 c-0.005-0.304,0.218-0.41,0.481-0.228l5.734,3.969C404.214,91.948,404.38,92.587,404.099,92.721z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1178_",
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M399.719,98.344c-0.005,2.141-0.652,3.919-1.603,4.503 c0,0-3.915-0.338-7.678-5.858C390.439,96.99,395.795,101.411,399.719,98.344z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploy);
export default __webpack_public_path__ + "static/media/deploy.bc17e7cdda432ea25dc44c2e799b64c7.svg";
export { ForwardRef as ReactComponent };